import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	DateTime: any;
	JSONString: any;
	PositiveInt: any;
	RichText: any;
	UUID: any;
};

export type AccordionBlock = StreamFieldInterface & {
	__typename?: "AccordionBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	heading?: Maybe<Scalars["String"]>;
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	sections?: Maybe<Array<Maybe<StreamFieldInterface>>>;
};

export type AccordionSection = StreamFieldInterface & {
	__typename?: "AccordionSection";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	details?: Maybe<Scalars["String"]>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	title?: Maybe<Scalars["String"]>;
};

export type BlockQuoteBlock = StreamFieldInterface & {
	__typename?: "BlockQuoteBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type BooleanBlock = StreamFieldInterface & {
	__typename?: "BooleanBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["Boolean"];
};

export type CaptionedImageBlock = StreamFieldInterface & {
	__typename?: "CaptionedImageBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	caption?: Maybe<Scalars["String"]>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image?: Maybe<ImageObjectType>;
	rawValue: Scalars["String"];
};

export type CharBlock = StreamFieldInterface & {
	__typename?: "CharBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type CheckboxFieldBlock = StreamFieldInterface & {
	__typename?: "CheckboxFieldBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	fieldLabel: Scalars["String"];
	fieldName: Scalars["String"];
	helpText?: Maybe<Scalars["String"]>;
	id?: Maybe<Scalars["String"]>;
	isRequired: Scalars["Boolean"];
	rawValue: Scalars["String"];
};

export type ChoiceBlock = StreamFieldInterface & {
	__typename?: "ChoiceBlock";
	blockType: Scalars["String"];
	choices: Array<ChoiceOption>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type ChoiceFieldBlock = StreamFieldInterface & {
	__typename?: "ChoiceFieldBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	choices: Array<Maybe<Scalars["String"]>>;
	field: Scalars["String"];
	fieldLabel: Scalars["String"];
	fieldName: Scalars["String"];
	fieldType: Scalars["String"];
	helpText?: Maybe<Scalars["String"]>;
	id?: Maybe<Scalars["String"]>;
	isRequired: Scalars["Boolean"];
	rawValue: Scalars["String"];
};

export type ChoiceOption = {
	__typename?: "ChoiceOption";
	key: Scalars["String"];
	value: Scalars["String"];
};

/** Collection type */
export type CollectionObjectType = {
	__typename?: "CollectionObjectType";
	ancestors: Array<Maybe<CollectionObjectType>>;
	depth: Scalars["Int"];
	descendants: Array<Maybe<CollectionObjectType>>;
	id: Scalars["ID"];
	name: Scalars["String"];
	numchild: Scalars["Int"];
	path: Scalars["String"];
};

export type ContactMutationInput = {
	clientMutationId?: InputMaybe<Scalars["String"]>;
	email: Scalars["String"];
	firstName: Scalars["String"];
	message: Scalars["String"];
	pageId: Scalars["Int"];
	phoneNumber?: InputMaybe<Scalars["String"]>;
	role: Scalars["String"];
	subject: Scalars["String"];
	surname: Scalars["String"];
};

export type ContactMutationPayload = {
	__typename?: "ContactMutationPayload";
	clientMutationId?: Maybe<Scalars["String"]>;
	email: Scalars["String"];
	errors?: Maybe<Array<Maybe<ErrorType>>>;
	firstName: Scalars["String"];
	message: Scalars["String"];
	pageId: Scalars["Int"];
	phoneNumber?: Maybe<Scalars["String"]>;
	role: Scalars["String"];
	subject: Scalars["String"];
	surname: Scalars["String"];
};

export type ContactPage = PageInterface & {
	__typename?: "ContactPage";
	aliasOf?: Maybe<Page>;
	ancestors: Array<PageInterface>;
	children: Array<PageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<PageInterface>;
	draftTitle: Scalars["String"];
	emailTo?: Maybe<Scalars["String"]>;
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	id?: Maybe<Scalars["ID"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	nextSiblings: Array<PageInterface>;
	numchild: Scalars["Int"];
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<PageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<PageInterface>;
	roles: Array<Scalars["String"]>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchImage?: Maybe<ImageObjectType>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<PageInterface>;
	slug: Scalars["String"];
	subjects: Array<Scalars["String"]>;
	thankYouText?: Maybe<Scalars["RichText"]>;
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type ContactPageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContactPageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContactPageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContactPageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContactPagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContactPageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContentPage = PageInterface & {
	__typename?: "ContentPage";
	aliasOf?: Maybe<Page>;
	ancestors: Array<PageInterface>;
	body?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	children: Array<PageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<PageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	heroImage?: Maybe<ImageObjectType>;
	id?: Maybe<Scalars["ID"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	nextSiblings: Array<PageInterface>;
	numchild: Scalars["Int"];
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<PageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<PageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchImage?: Maybe<ImageObjectType>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<PageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type ContentPageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContentPageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContentPageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContentPageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContentPagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ContentPageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type DateBlock = StreamFieldInterface & {
	__typename?: "DateBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type DateBlockValueArgs = {
	format?: InputMaybe<Scalars["String"]>;
};

export type DateTimeBlock = StreamFieldInterface & {
	__typename?: "DateTimeBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type DateTimeBlockValueArgs = {
	format?: InputMaybe<Scalars["String"]>;
};

export type DecimalBlock = StreamFieldInterface & {
	__typename?: "DecimalBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["Float"];
};

export type DocumentChooserBlock = StreamFieldInterface & {
	__typename?: "DocumentChooserBlock";
	blockType: Scalars["String"];
	document: DocumentObjectType;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

/**
 * Base document type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type DocumentObjectType = {
	__typename?: "DocumentObjectType";
	collection: CollectionObjectType;
	createdAt: Scalars["DateTime"];
	file: Scalars["String"];
	fileHash: Scalars["String"];
	fileSize?: Maybe<Scalars["Int"]>;
	id: Scalars["ID"];
	tags: Array<TagObjectType>;
	title: Scalars["String"];
	url: Scalars["String"];
};

export type EmailBlock = StreamFieldInterface & {
	__typename?: "EmailBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type EmbedBlock = StreamFieldInterface & {
	__typename?: "EmbedBlock";
	blockType: Scalars["String"];
	embed?: Maybe<Scalars["String"]>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawEmbed?: Maybe<Scalars["JSONString"]>;
	rawValue: Scalars["String"];
	url: Scalars["String"];
	value: Scalars["String"];
};

export type EnquiryRole = {
	__typename?: "EnquiryRole";
	id?: Maybe<Scalars["ID"]>;
};

export type EnquirySubject = {
	__typename?: "EnquirySubject";
	id?: Maybe<Scalars["ID"]>;
};

export type ErrorType = {
	__typename?: "ErrorType";
	field: Scalars["String"];
	messages: Array<Scalars["String"]>;
};

export type ExternalLinkBlock = StreamFieldInterface & {
	__typename?: "ExternalLinkBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	href: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	text: Scalars["String"];
};

export type FeaturedContentBlock = StreamFieldInterface & {
	__typename?: "FeaturedContentBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	content: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image?: Maybe<ImageObjectType>;
	link?: Maybe<PageInterface>;
	linkText?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	title?: Maybe<Scalars["String"]>;
};

export type FieldBlock = StreamFieldInterface & {
	__typename?: "FieldBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	defaultValue?: Maybe<Scalars["String"]>;
	field: Scalars["String"];
	fieldLabel: Scalars["String"];
	fieldName: Scalars["String"];
	fieldType: Scalars["String"];
	helpText?: Maybe<Scalars["String"]>;
	id?: Maybe<Scalars["String"]>;
	isRequired: Scalars["Boolean"];
	placeholder?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

export type FileFieldBlock = StreamFieldInterface & {
	__typename?: "FileFieldBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	fieldLabel: Scalars["String"];
	fieldName: Scalars["String"];
	helpText?: Maybe<Scalars["String"]>;
	id?: Maybe<Scalars["String"]>;
	isRequired: Scalars["Boolean"];
	rawValue: Scalars["String"];
};

export type FloatBlock = StreamFieldInterface & {
	__typename?: "FloatBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["Float"];
};

export type FooterSettings = {
	__typename?: "FooterSettings";
	acknowledgementOfCountry: Scalars["String"];
	address: Scalars["String"];
	contactPhone: Scalars["String"];
	id?: Maybe<Scalars["ID"]>;
	legalLinks?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	socialMediaLinks?: Maybe<Array<Maybe<StreamFieldInterface>>>;
};

export type FormBlock = StreamFieldInterface & {
	__typename?: "FormBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	emailTo: Scalars["String"];
	field: Scalars["String"];
	formFields?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	formTitle: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	thankYouMessage: Scalars["String"];
};

export type FullWidthImageBlock = StreamFieldInterface & {
	__typename?: "FullWidthImageBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image: StreamFieldInterface;
	rawValue: Scalars["String"];
};

export type HomePage = PageInterface & {
	__typename?: "HomePage";
	aliasOf?: Maybe<Page>;
	ancestors: Array<PageInterface>;
	body?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	children: Array<PageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<PageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	heroImage?: Maybe<ImageObjectType>;
	heroLinks?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	heroTagline?: Maybe<Scalars["String"]>;
	id?: Maybe<Scalars["ID"]>;
	introLinks?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	introText?: Maybe<Scalars["String"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	learnMoreLabel?: Maybe<Scalars["String"]>;
	learnMoreLink?: Maybe<Scalars["String"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	nextSiblings: Array<PageInterface>;
	numchild: Scalars["Int"];
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<PageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<PageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchImage?: Maybe<ImageObjectType>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<PageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type HomePageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type HomePageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type HomePageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type HomePageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type HomePagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type HomePageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ImageChooserBlock = StreamFieldInterface & {
	__typename?: "ImageChooserBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image: ImageObjectType;
	rawValue: Scalars["String"];
};

export type ImageContentBlock = StreamFieldInterface & {
	__typename?: "ImageContentBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	content: Scalars["String"];
	direction: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image: ImageObjectType;
	link?: Maybe<Scalars["String"]>;
	linkText?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	superTitle?: Maybe<Scalars["String"]>;
	title?: Maybe<Scalars["String"]>;
};

export type ImageObjectType = {
	__typename?: "ImageObjectType";
	aspectRatio: Scalars["Float"];
	collection: CollectionObjectType;
	createdAt: Scalars["DateTime"];
	file: Scalars["String"];
	fileHash: Scalars["String"];
	fileSize?: Maybe<Scalars["Int"]>;
	focalPointHeight?: Maybe<Scalars["Int"]>;
	focalPointWidth?: Maybe<Scalars["Int"]>;
	focalPointX?: Maybe<Scalars["Int"]>;
	focalPointY?: Maybe<Scalars["Int"]>;
	height: Scalars["Int"];
	id: Scalars["ID"];
	isSvg: Scalars["Boolean"];
	rendition?: Maybe<ImageRenditionObjectType>;
	renditions: Array<ImageRenditionObjectType>;
	sizes: Scalars["String"];
	/** @deprecated Use the `url` attribute */
	src: Scalars["String"];
	srcSet?: Maybe<Scalars["String"]>;
	tags: Array<TagObjectType>;
	title: Scalars["String"];
	url: Scalars["String"];
	width: Scalars["Int"];
};

export type ImageObjectTypeRenditionArgs = {
	bgcolor?: InputMaybe<Scalars["String"]>;
	fill?: InputMaybe<Scalars["String"]>;
	format?: InputMaybe<Scalars["String"]>;
	height?: InputMaybe<Scalars["Int"]>;
	jpegquality?: InputMaybe<Scalars["Int"]>;
	max?: InputMaybe<Scalars["String"]>;
	min?: InputMaybe<Scalars["String"]>;
	preserveSvg?: InputMaybe<Scalars["Boolean"]>;
	webpquality?: InputMaybe<Scalars["Int"]>;
	width?: InputMaybe<Scalars["Int"]>;
};

export type ImageObjectTypeSrcSetArgs = {
	format?: InputMaybe<Scalars["String"]>;
	preserveSvg?: InputMaybe<Scalars["Boolean"]>;
	sizes?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type ImageRenditionObjectType = {
	__typename?: "ImageRenditionObjectType";
	alt: Scalars["String"];
	backgroundPositionStyle: Scalars["String"];
	file: Scalars["String"];
	filterSpec: Scalars["String"];
	focalPoint?: Maybe<Scalars["String"]>;
	focalPointKey: Scalars["String"];
	height: Scalars["Int"];
	id: Scalars["ID"];
	image: ImageObjectType;
	url: Scalars["String"];
	width: Scalars["Int"];
};

export type IntegerBlock = StreamFieldInterface & {
	__typename?: "IntegerBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["Int"];
};

export type InternalLinkBlock = StreamFieldInterface & {
	__typename?: "InternalLinkBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	href: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	text: Scalars["String"];
};

export type LandingPage = PageInterface & {
	__typename?: "LandingPage";
	aliasOf?: Maybe<Page>;
	ancestors: Array<PageInterface>;
	body?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	children: Array<PageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<PageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	heroImage?: Maybe<ImageObjectType>;
	heroLinks?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	heroTagline?: Maybe<Scalars["String"]>;
	id?: Maybe<Scalars["ID"]>;
	introLinks?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	introText?: Maybe<Scalars["String"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	learnMoreLabel?: Maybe<Scalars["String"]>;
	learnMoreLink?: Maybe<Scalars["String"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	nextSiblings: Array<PageInterface>;
	numchild: Scalars["Int"];
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<PageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<PageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchImage?: Maybe<ImageObjectType>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<PageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type LandingPageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type LandingPageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type LandingPageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type LandingPageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type LandingPagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type LandingPageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ListBlock = StreamFieldInterface & {
	__typename?: "ListBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	items: Array<StreamFieldInterface>;
	rawValue: Scalars["String"];
};

export type LogoListBlock = StreamFieldInterface & {
	__typename?: "LogoListBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	logos: Array<Maybe<ImageObjectType>>;
	rawValue: Scalars["String"];
	title: Scalars["String"];
};

export type MenuSettings = {
	__typename?: "MenuSettings";
	id?: Maybe<Scalars["ID"]>;
	menu?: Maybe<Array<Maybe<StreamFieldInterface>>>;
};

export type Mutation = {
	__typename?: "Mutation";
	contact?: Maybe<ContactMutationPayload>;
};

export type MutationContactArgs = {
	input: ContactMutationInput;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type Page = PageInterface & {
	__typename?: "Page";
	aliasOf?: Maybe<Page>;
	aliases: Array<Page>;
	ancestors: Array<PageInterface>;
	children: Array<PageInterface>;
	contactpage?: Maybe<ContactPage>;
	contentType: Scalars["String"];
	contentpage?: Maybe<ContentPage>;
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<PageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	homepage?: Maybe<HomePage>;
	id?: Maybe<Scalars["ID"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	nextSiblings: Array<PageInterface>;
	numchild: Scalars["Int"];
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<PageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<PageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<PageInterface>;
	sitesRootedHere: Array<SiteObjectType>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type PageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type PageChooserBlock = StreamFieldInterface & {
	__typename?: "PageChooserBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	page: PageInterface;
	rawValue: Scalars["String"];
};

export type PageInterface = {
	ancestors: Array<PageInterface>;
	children: Array<PageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<PageInterface>;
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	id?: Maybe<Scalars["ID"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	nextSiblings: Array<PageInterface>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<PageInterface>;
	previousSiblings: Array<PageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<PageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type PageInterfaceAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type PageInterfaceChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type PageInterfaceDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type PageInterfaceNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type PageInterfacePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type PageInterfaceSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type ProfileBlock = StreamFieldInterface & {
	__typename?: "ProfileBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	content: Scalars["RichText"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image: ImageObjectType;
	rawValue: Scalars["String"];
	title: Scalars["String"];
};

export type ProfileListBlock = StreamFieldInterface & {
	__typename?: "ProfileListBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	intro?: Maybe<Scalars["String"]>;
	profiles?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	rawValue: Scalars["String"];
	title: Scalars["String"];
};

export type Query = {
	__typename?: "Query";
	collections: Array<Maybe<CollectionObjectType>>;
	document?: Maybe<DocumentObjectType>;
	documentType: Scalars["String"];
	documents: Array<DocumentObjectType>;
	footerSettings?: Maybe<FooterSettings>;
	image?: Maybe<ImageObjectType>;
	imageType: Scalars["String"];
	images: Array<ImageObjectType>;
	menuSettings?: Maybe<MenuSettings>;
	page?: Maybe<PageInterface>;
	pages: Array<PageInterface>;
	redirects: Array<Redirect>;
	resource: Resource;
	resources?: Maybe<Array<Maybe<ResourceNode>>>;
	search: Array<Search>;
	setting?: Maybe<SettingsObjectType>;
	settings: Array<SettingsObjectType>;
	site?: Maybe<SiteObjectType>;
	sites: Array<SiteObjectType>;
	snippets: Array<SnippetObjectType>;
	tag?: Maybe<TagObjectType>;
	tags: Array<TagObjectType>;
};

export type QueryCollectionsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
};

export type QueryDocumentArgs = {
	id?: InputMaybe<Scalars["ID"]>;
};

export type QueryDocumentsArgs = {
	collection?: InputMaybe<Scalars["ID"]>;
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type QueryFooterSettingsArgs = {
	order?: InputMaybe<Scalars["String"]>;
};

export type QueryImageArgs = {
	id?: InputMaybe<Scalars["ID"]>;
};

export type QueryImagesArgs = {
	collection?: InputMaybe<Scalars["ID"]>;
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type QueryMenuSettingsArgs = {
	order?: InputMaybe<Scalars["String"]>;
};

export type QueryPageArgs = {
	contentType?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	inSite?: InputMaybe<Scalars["Boolean"]>;
	site?: InputMaybe<Scalars["String"]>;
	slug?: InputMaybe<Scalars["String"]>;
	token?: InputMaybe<Scalars["String"]>;
	urlPath?: InputMaybe<Scalars["String"]>;
};

export type QueryPagesArgs = {
	ancestor?: InputMaybe<Scalars["ID"]>;
	contentType?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	inSite?: InputMaybe<Scalars["Boolean"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	parent?: InputMaybe<Scalars["ID"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
	site?: InputMaybe<Scalars["String"]>;
};

export type QueryResourceArgs = {
	id?: InputMaybe<Scalars["ID"]>;
};

export type QueryResourcesArgs = {
	search?: InputMaybe<Scalars["String"]>;
};

export type QuerySearchArgs = {
	query?: InputMaybe<Scalars["String"]>;
};

export type QuerySettingArgs = {
	name?: InputMaybe<Scalars["String"]>;
	site?: InputMaybe<Scalars["String"]>;
};

export type QuerySettingsArgs = {
	name?: InputMaybe<Scalars["String"]>;
	site?: InputMaybe<Scalars["String"]>;
};

export type QuerySiteArgs = {
	hostname?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
};

export type QuerySitesArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type QueryTagArgs = {
	id?: InputMaybe<Scalars["ID"]>;
};

export type QueryTagsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
};

export type QuickLinksBlock = StreamFieldInterface & {
	__typename?: "QuickLinksBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	links?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	rawValue: Scalars["String"];
	title: Scalars["String"];
};

export type QuoteBlock = StreamFieldInterface & {
	__typename?: "QuoteBlock";
	attribution?: Maybe<Scalars["String"]>;
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	quote: Scalars["String"];
	rawValue: Scalars["String"];
};

export type RawHtmlBlock = StreamFieldInterface & {
	__typename?: "RawHTMLBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type Redirect = {
	__typename?: "Redirect";
	isPermanent: Scalars["Boolean"];
	newUrl?: Maybe<Scalars["String"]>;
	oldPath: Scalars["String"];
	oldUrl: Scalars["String"];
	page?: Maybe<PageInterface>;
	site: SiteObjectType;
};

export type RegexBlock = StreamFieldInterface & {
	__typename?: "RegexBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type Resource = {
	__typename?: "Resource";
	id?: Maybe<Scalars["ID"]>;
	image?: Maybe<ImageObjectType>;
	resourceType: Scalars["String"];
	title: Scalars["String"];
	url: Scalars["String"];
};

export type ResourceNode = {
	__typename?: "ResourceNode";
	id: Scalars["ID"];
	image?: Maybe<ImageObjectType>;
	/** If the resource is a Wagtail page, use this field. This will supercede the URL field. */
	page?: Maybe<ContentPage>;
	resourceType?: Maybe<Scalars["String"]>;
	title: Scalars["String"];
	url?: Maybe<Scalars["String"]>;
};

export type ResourceType = {
	__typename?: "ResourceType";
	id?: Maybe<Scalars["ID"]>;
};

export type ResourcesBlock = StreamFieldInterface & {
	__typename?: "ResourcesBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	featured?: Maybe<Scalars["Boolean"]>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	resources: Array<Maybe<Resource>>;
	title: Scalars["String"];
};

export type ResourcesBlockResourcesArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type RichTextBlock = StreamFieldInterface & {
	__typename?: "RichTextBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type RichtextWithHeadingBlock = StreamFieldInterface & {
	__typename?: "RichtextWithHeadingBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	heading: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	richtext: Scalars["RichText"];
};

export type RichtextWithImageBlock = StreamFieldInterface & {
	__typename?: "RichtextWithImageBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image: StreamFieldInterface;
	rawValue: Scalars["String"];
	richtext?: Maybe<Scalars["RichText"]>;
};

export type Search =
	| ContactPage
	| ContentPage
	| EnquiryRole
	| EnquirySubject
	| FooterSettings
	| HomePage
	| LandingPage
	| MenuSettings
	| Page
	| Resource
	| ResourceType;

export type SettingsObjectType = FooterSettings | MenuSettings;

export type SiteObjectType = {
	__typename?: "SiteObjectType";
	footersettings?: Maybe<FooterSettings>;
	hostname: Scalars["String"];
	id: Scalars["ID"];
	/** If true, this site will handle requests for all other hostnames that do not have a site entry of their own */
	isDefaultSite: Scalars["Boolean"];
	menusettings?: Maybe<MenuSettings>;
	page?: Maybe<PageInterface>;
	pages: Array<PageInterface>;
	/** Set this to something other than 80 if you need a specific port number to appear in URLs (e.g. development on port 8000). Does not affect request handling (so port forwarding still works). */
	port: Scalars["Int"];
	rootPage: Page;
	/** Human-readable name for the site. */
	siteName: Scalars["String"];
};

export type SiteObjectTypePageArgs = {
	contentType?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	slug?: InputMaybe<Scalars["String"]>;
	token?: InputMaybe<Scalars["String"]>;
	urlPath?: InputMaybe<Scalars["String"]>;
};

export type SiteObjectTypePagesArgs = {
	contentType?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type SnippetChooserBlock = StreamFieldInterface & {
	__typename?: "SnippetChooserBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	snippet: SnippetObjectType;
};

export type SnippetObjectType = Resource | ResourceType;

export type StatBlock = StreamFieldInterface & {
	__typename?: "StatBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	stat: Scalars["String"];
	statDescription: Scalars["String"];
};

export type StaticBlock = StreamFieldInterface & {
	__typename?: "StaticBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type StatsBlock = StreamFieldInterface & {
	__typename?: "StatsBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image: ImageObjectType;
	rawValue: Scalars["String"];
	stats?: Maybe<Array<Maybe<StreamFieldInterface>>>;
	title: Scalars["String"];
};

export type StreamBlock = StreamFieldInterface & {
	__typename?: "StreamBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

export type StreamFieldBlock = StreamFieldInterface & {
	__typename?: "StreamFieldBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type StreamFieldInterface = {
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

export type StructBlock = StreamFieldInterface & {
	__typename?: "StructBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

export type TagObjectType = {
	__typename?: "TagObjectType";
	id: Scalars["ID"];
	name: Scalars["String"];
};

export type TextBlock = StreamFieldInterface & {
	__typename?: "TextBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type TimeBlock = StreamFieldInterface & {
	__typename?: "TimeBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type TimeBlockValueArgs = {
	format?: InputMaybe<Scalars["String"]>;
};

export type UrlBlock = StreamFieldInterface & {
	__typename?: "URLBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type VideoEmbedBlock = StreamFieldInterface & {
	__typename?: "VideoEmbedBlock";
	blockType: Scalars["String"];
	blocks: Array<StreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	title: Scalars["String"];
	url: Scalars["String"];
};

export type GetHeaderMenuQueryVariables = Exact<{ [key: string]: never }>;

export type GetHeaderMenuQuery = {
	__typename?: "Query";
	menuSettings?: {
		__typename?: "MenuSettings";
		menu?: Array<
			| { __typename?: "AccordionBlock"; id?: string | null; blockType: string }
			| { __typename?: "AccordionSection"; id?: string | null; blockType: string }
			| { __typename?: "BlockQuoteBlock"; id?: string | null; blockType: string }
			| { __typename?: "BooleanBlock"; id?: string | null; blockType: string }
			| { __typename?: "CaptionedImageBlock"; id?: string | null; blockType: string }
			| { __typename?: "CharBlock"; id?: string | null; blockType: string }
			| { __typename?: "CheckboxFieldBlock"; id?: string | null; blockType: string }
			| { __typename?: "ChoiceBlock"; id?: string | null; blockType: string }
			| { __typename?: "ChoiceFieldBlock"; id?: string | null; blockType: string }
			| { __typename?: "DateBlock"; id?: string | null; blockType: string }
			| { __typename?: "DateTimeBlock"; id?: string | null; blockType: string }
			| { __typename?: "DecimalBlock"; id?: string | null; blockType: string }
			| { __typename?: "DocumentChooserBlock"; id?: string | null; blockType: string }
			| { __typename?: "EmailBlock"; id?: string | null; blockType: string }
			| { __typename?: "EmbedBlock"; id?: string | null; blockType: string }
			| { __typename?: "ExternalLinkBlock"; id?: string | null; blockType: string; href: string; text: string }
			| { __typename?: "FeaturedContentBlock"; id?: string | null; blockType: string }
			| { __typename?: "FieldBlock"; id?: string | null; blockType: string }
			| { __typename?: "FileFieldBlock"; id?: string | null; blockType: string }
			| { __typename?: "FloatBlock"; id?: string | null; blockType: string }
			| { __typename?: "FormBlock"; id?: string | null; blockType: string }
			| { __typename?: "ImageChooserBlock"; id?: string | null; blockType: string }
			| { __typename?: "ImageContentBlock"; id?: string | null; blockType: string }
			| { __typename?: "IntegerBlock"; id?: string | null; blockType: string }
			| { __typename?: "InternalLinkBlock"; id?: string | null; blockType: string; href: string; text: string }
			| { __typename?: "ListBlock"; id?: string | null; blockType: string }
			| { __typename?: "LogoListBlock"; id?: string | null; blockType: string }
			| { __typename?: "PageChooserBlock"; id?: string | null; blockType: string }
			| { __typename?: "ProfileBlock"; id?: string | null; blockType: string }
			| { __typename?: "ProfileListBlock"; id?: string | null; blockType: string }
			| { __typename?: "QuickLinksBlock"; id?: string | null; blockType: string }
			| { __typename?: "QuoteBlock"; id?: string | null; blockType: string }
			| { __typename?: "RawHTMLBlock"; id?: string | null; blockType: string }
			| { __typename?: "RegexBlock"; id?: string | null; blockType: string }
			| { __typename?: "ResourcesBlock"; id?: string | null; blockType: string }
			| { __typename?: "RichTextBlock"; id?: string | null; blockType: string }
			| { __typename?: "RichtextWithHeadingBlock"; id?: string | null; blockType: string }
			| { __typename?: "RichtextWithImageBlock"; id?: string | null; blockType: string }
			| { __typename?: "SnippetChooserBlock"; id?: string | null; blockType: string }
			| { __typename?: "StatBlock"; id?: string | null; blockType: string }
			| { __typename?: "StaticBlock"; id?: string | null; blockType: string }
			| { __typename?: "StatsBlock"; id?: string | null; blockType: string }
			| { __typename?: "StreamBlock"; id?: string | null; blockType: string }
			| { __typename?: "StreamFieldBlock"; id?: string | null; blockType: string }
			| { __typename?: "StructBlock"; id?: string | null; blockType: string }
			| { __typename?: "TextBlock"; id?: string | null; blockType: string }
			| { __typename?: "TimeBlock"; id?: string | null; blockType: string }
			| { __typename?: "URLBlock"; id?: string | null; blockType: string }
			| { __typename?: "VideoEmbedBlock"; id?: string | null; blockType: string }
			| null
		> | null;
	} | null;
};

export type InternalFragment = { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string };

export type ExternalFragment = { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string };

export type GetFooterSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFooterSettingsQuery = {
	__typename?: "Query";
	footerSettings?: {
		__typename?: "FooterSettings";
		acknowledgementOfCountry: string;
		address: string;
		contactPhone: string;
		socialMediaLinks?: Array<
			| { __typename?: "AccordionBlock" }
			| { __typename?: "AccordionSection" }
			| { __typename?: "BlockQuoteBlock" }
			| { __typename?: "BooleanBlock" }
			| { __typename?: "CaptionedImageBlock" }
			| { __typename?: "CharBlock" }
			| { __typename?: "CheckboxFieldBlock" }
			| { __typename?: "ChoiceBlock" }
			| { __typename?: "ChoiceFieldBlock" }
			| { __typename?: "DateBlock" }
			| { __typename?: "DateTimeBlock" }
			| { __typename?: "DecimalBlock" }
			| { __typename?: "DocumentChooserBlock" }
			| { __typename?: "EmailBlock" }
			| { __typename?: "EmbedBlock" }
			| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
			| { __typename?: "FeaturedContentBlock" }
			| { __typename?: "FieldBlock" }
			| { __typename?: "FileFieldBlock" }
			| { __typename?: "FloatBlock" }
			| { __typename?: "FormBlock" }
			| { __typename?: "ImageChooserBlock" }
			| { __typename?: "ImageContentBlock" }
			| { __typename?: "IntegerBlock" }
			| { __typename?: "InternalLinkBlock" }
			| { __typename?: "ListBlock" }
			| { __typename?: "LogoListBlock" }
			| { __typename?: "PageChooserBlock" }
			| { __typename?: "ProfileBlock" }
			| { __typename?: "ProfileListBlock" }
			| { __typename?: "QuickLinksBlock" }
			| { __typename?: "QuoteBlock" }
			| { __typename?: "RawHTMLBlock" }
			| { __typename?: "RegexBlock" }
			| { __typename?: "ResourcesBlock" }
			| { __typename?: "RichTextBlock" }
			| { __typename?: "RichtextWithHeadingBlock" }
			| { __typename?: "RichtextWithImageBlock" }
			| { __typename?: "SnippetChooserBlock" }
			| { __typename?: "StatBlock" }
			| { __typename?: "StaticBlock" }
			| { __typename?: "StatsBlock" }
			| { __typename?: "StreamBlock" }
			| { __typename?: "StreamFieldBlock" }
			| { __typename?: "StructBlock" }
			| { __typename?: "TextBlock" }
			| { __typename?: "TimeBlock" }
			| { __typename?: "URLBlock" }
			| { __typename?: "VideoEmbedBlock" }
			| null
		> | null;
		legalLinks?: Array<
			| { __typename?: "AccordionBlock" }
			| { __typename?: "AccordionSection" }
			| { __typename?: "BlockQuoteBlock" }
			| { __typename?: "BooleanBlock" }
			| { __typename?: "CaptionedImageBlock" }
			| { __typename?: "CharBlock" }
			| { __typename?: "CheckboxFieldBlock" }
			| { __typename?: "ChoiceBlock" }
			| { __typename?: "ChoiceFieldBlock" }
			| { __typename?: "DateBlock" }
			| { __typename?: "DateTimeBlock" }
			| { __typename?: "DecimalBlock" }
			| { __typename?: "DocumentChooserBlock" }
			| { __typename?: "EmailBlock" }
			| { __typename?: "EmbedBlock" }
			| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
			| { __typename?: "FeaturedContentBlock" }
			| { __typename?: "FieldBlock" }
			| { __typename?: "FileFieldBlock" }
			| { __typename?: "FloatBlock" }
			| { __typename?: "FormBlock" }
			| { __typename?: "ImageChooserBlock" }
			| { __typename?: "ImageContentBlock" }
			| { __typename?: "IntegerBlock" }
			| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
			| { __typename?: "ListBlock" }
			| { __typename?: "LogoListBlock" }
			| { __typename?: "PageChooserBlock" }
			| { __typename?: "ProfileBlock" }
			| { __typename?: "ProfileListBlock" }
			| { __typename?: "QuickLinksBlock" }
			| { __typename?: "QuoteBlock" }
			| { __typename?: "RawHTMLBlock" }
			| { __typename?: "RegexBlock" }
			| { __typename?: "ResourcesBlock" }
			| { __typename?: "RichTextBlock" }
			| { __typename?: "RichtextWithHeadingBlock" }
			| { __typename?: "RichtextWithImageBlock" }
			| { __typename?: "SnippetChooserBlock" }
			| { __typename?: "StatBlock" }
			| { __typename?: "StaticBlock" }
			| { __typename?: "StatsBlock" }
			| { __typename?: "StreamBlock" }
			| { __typename?: "StreamFieldBlock" }
			| { __typename?: "StructBlock" }
			| { __typename?: "TextBlock" }
			| { __typename?: "TimeBlock" }
			| { __typename?: "URLBlock" }
			| { __typename?: "VideoEmbedBlock" }
			| null
		> | null;
	} | null;
};

export type ContactMutationVariables = Exact<{
	input: ContactMutationInput;
}>;

export type ContactMutation = {
	__typename?: "Mutation";
	contact?: {
		__typename?: "ContactMutationPayload";
		errors?: Array<{ __typename?: "ErrorType"; field: string; messages: Array<string> } | null> | null;
	} | null;
};

export type AllPagesQueryVariables = Exact<{
	hostname: Scalars["String"];
}>;

export type AllPagesQuery = {
	__typename?: "Query";
	site?: {
		__typename?: "SiteObjectType";
		pages: Array<
			| { __typename?: "ContactPage"; id?: string | null; live: boolean; urlPath: string }
			| { __typename?: "ContentPage"; id?: string | null; live: boolean; urlPath: string }
			| { __typename?: "HomePage"; id?: string | null; live: boolean; urlPath: string }
			| { __typename?: "LandingPage"; id?: string | null; live: boolean; urlPath: string }
			| { __typename?: "Page"; id?: string | null; live: boolean; urlPath: string }
		>;
	} | null;
};

export type PageQueryVariables = Exact<{
	hostname: Scalars["String"];
	urlPath: Scalars["String"];
	token?: InputMaybe<Scalars["String"]>;
	contentType?: InputMaybe<Scalars["String"]>;
}>;

export type PageQuery = {
	__typename?: "Query";
	site?: {
		__typename?: "SiteObjectType";
		siteName: string;
		hostname: string;
		page?:
			| {
					__typename?: "ContactPage";
					id?: string | null;
					thankYouText?: any | null;
					subjects: Array<string>;
					roles: Array<string>;
					title: string;
					slug: string;
					url?: string | null;
					urlPath: string;
					pageType?: string | null;
					seoTitle: string;
					searchDescription?: string | null;
			  }
			| {
					__typename?: "ContentPage";
					id?: string | null;
					title: string;
					slug: string;
					url?: string | null;
					urlPath: string;
					pageType?: string | null;
					seoTitle: string;
					searchDescription?: string | null;
					searchImage?: {
						__typename?: "ImageObjectType";
						rendition?: {
							__typename?: "ImageRenditionObjectType";
							url: string;
							width: number;
							height: number;
							image: { __typename?: "ImageObjectType"; title: string };
						} | null;
					} | null;
					heroImage?: {
						__typename?: "ImageObjectType";
						rendition?: {
							__typename?: "ImageRenditionObjectType";
							url: string;
							width: number;
							height: number;
							image: { __typename?: "ImageObjectType"; title: string };
						} | null;
					} | null;
					body?: Array<
						| { __typename?: "AccordionBlock"; id?: string | null; blockType: string }
						| { __typename?: "AccordionSection"; id?: string | null; blockType: string }
						| { __typename?: "BlockQuoteBlock"; id?: string | null; blockType: string }
						| { __typename?: "BooleanBlock"; id?: string | null; blockType: string }
						| { __typename?: "CaptionedImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "CharBlock"; id?: string | null; blockType: string }
						| { __typename?: "CheckboxFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "ChoiceBlock"; id?: string | null; blockType: string }
						| { __typename?: "ChoiceFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "DateBlock"; id?: string | null; blockType: string }
						| { __typename?: "DateTimeBlock"; id?: string | null; blockType: string }
						| { __typename?: "DecimalBlock"; id?: string | null; blockType: string }
						| { __typename?: "DocumentChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "EmailBlock"; id?: string | null; blockType: string }
						| { __typename?: "EmbedBlock"; id?: string | null; blockType: string }
						| { __typename?: "ExternalLinkBlock"; id?: string | null; blockType: string }
						| { __typename?: "FeaturedContentBlock"; id?: string | null; blockType: string }
						| { __typename?: "FieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "FileFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "FloatBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "FormBlock";
								formTitle: string;
								emailTo: string;
								thankYouMessage: string;
								id?: string | null;
								blockType: string;
								formFields?: Array<
									| { __typename?: "AccordionBlock" }
									| { __typename?: "AccordionSection" }
									| { __typename?: "BlockQuoteBlock" }
									| { __typename?: "BooleanBlock" }
									| { __typename?: "CaptionedImageBlock" }
									| { __typename?: "CharBlock" }
									| {
											__typename?: "CheckboxFieldBlock";
											fieldLabel: string;
											fieldName: string;
											isRequired: boolean;
											helpText?: string | null;
									  }
									| { __typename?: "ChoiceBlock" }
									| {
											__typename?: "ChoiceFieldBlock";
											fieldLabel: string;
											fieldName: string;
											fieldType: string;
											isRequired: boolean;
											choices: Array<string | null>;
											helpText?: string | null;
									  }
									| { __typename?: "DateBlock" }
									| { __typename?: "DateTimeBlock" }
									| { __typename?: "DecimalBlock" }
									| { __typename?: "DocumentChooserBlock" }
									| { __typename?: "EmailBlock" }
									| { __typename?: "EmbedBlock" }
									| { __typename?: "ExternalLinkBlock" }
									| { __typename?: "FeaturedContentBlock" }
									| {
											__typename?: "FieldBlock";
											fieldLabel: string;
											fieldName: string;
											fieldType: string;
											isRequired: boolean;
											placeholder?: string | null;
											defaultValue?: string | null;
											helpText?: string | null;
									  }
									| {
											__typename?: "FileFieldBlock";
											fieldLabel: string;
											fieldName: string;
											helpText?: string | null;
											isRequired: boolean;
									  }
									| { __typename?: "FloatBlock" }
									| { __typename?: "FormBlock" }
									| { __typename?: "FullWidthImageBlock" }
									| { __typename?: "ImageBlock" }
									| { __typename?: "ImageChooserBlock" }
									| { __typename?: "ImageContentBlock" }
									| { __typename?: "IntegerBlock" }
									| { __typename?: "InternalLinkBlock" }
									| { __typename?: "ListBlock" }
									| { __typename?: "LogoListBlock" }
									| { __typename?: "PageChooserBlock" }
									| { __typename?: "ProfileBlock" }
									| { __typename?: "ProfileListBlock" }
									| { __typename?: "QuickLinksBlock" }
									| { __typename?: "QuoteBlock" }
									| { __typename?: "RawHTMLBlock" }
									| { __typename?: "RegexBlock" }
									| { __typename?: "ResourcesBlock" }
									| { __typename?: "RichTextBlock" }
									| { __typename?: "RichtextWithHeadingBlock" }
									| { __typename?: "RichtextWithImageBlock" }
									| { __typename?: "SnippetChooserBlock" }
									| { __typename?: "StatBlock" }
									| { __typename?: "StaticBlock" }
									| { __typename?: "StatsBlock" }
									| { __typename?: "StreamBlock" }
									| { __typename?: "StreamFieldBlock" }
									| { __typename?: "StructBlock" }
									| { __typename?: "TextBlock" }
									| { __typename?: "TimeBlock" }
									| { __typename?: "URLBlock" }
									| { __typename?: "VideoEmbedBlock" }
									| null
								> | null;
						  }
						| {
								__typename?: "FullWidthImageBlock";
								id?: string | null;
								blockType: string;
								captionedImage:
									| { __typename?: "AccordionBlock" }
									| { __typename?: "AccordionSection" }
									| { __typename?: "BlockQuoteBlock" }
									| { __typename?: "BooleanBlock" }
									| {
											__typename?: "CaptionedImageBlock";
											caption?: string | null;
											image?: {
												__typename?: "ImageObjectType";
												rendition?: {
													__typename?: "ImageRenditionObjectType";
													url: string;
													width: number;
													height: number;
													image: { __typename?: "ImageObjectType"; title: string };
												} | null;
											} | null;
									  }
									| { __typename?: "CharBlock" }
									| { __typename?: "CheckboxFieldBlock" }
									| { __typename?: "ChoiceBlock" }
									| { __typename?: "ChoiceFieldBlock" }
									| { __typename?: "DateBlock" }
									| { __typename?: "DateTimeBlock" }
									| { __typename?: "DecimalBlock" }
									| { __typename?: "DocumentChooserBlock" }
									| { __typename?: "EmailBlock" }
									| { __typename?: "EmbedBlock" }
									| { __typename?: "ExternalLinkBlock" }
									| { __typename?: "FeaturedContentBlock" }
									| { __typename?: "FieldBlock" }
									| { __typename?: "FileFieldBlock" }
									| { __typename?: "FloatBlock" }
									| { __typename?: "FormBlock" }
									| { __typename?: "FullWidthImageBlock" }
									| { __typename?: "ImageBlock" }
									| { __typename?: "ImageChooserBlock" }
									| { __typename?: "ImageContentBlock" }
									| { __typename?: "IntegerBlock" }
									| { __typename?: "InternalLinkBlock" }
									| { __typename?: "ListBlock" }
									| { __typename?: "LogoListBlock" }
									| { __typename?: "PageChooserBlock" }
									| { __typename?: "ProfileBlock" }
									| { __typename?: "ProfileListBlock" }
									| { __typename?: "QuickLinksBlock" }
									| { __typename?: "QuoteBlock" }
									| { __typename?: "RawHTMLBlock" }
									| { __typename?: "RegexBlock" }
									| { __typename?: "ResourcesBlock" }
									| { __typename?: "RichTextBlock" }
									| { __typename?: "RichtextWithHeadingBlock" }
									| { __typename?: "RichtextWithImageBlock" }
									| { __typename?: "SnippetChooserBlock" }
									| { __typename?: "StatBlock" }
									| { __typename?: "StaticBlock" }
									| { __typename?: "StatsBlock" }
									| { __typename?: "StreamBlock" }
									| { __typename?: "StreamFieldBlock" }
									| { __typename?: "StructBlock" }
									| { __typename?: "TextBlock" }
									| { __typename?: "TimeBlock" }
									| { __typename?: "URLBlock" }
									| { __typename?: "VideoEmbedBlock" };
						  }
						| { __typename?: "ImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "ImageChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "ImageContentBlock"; id?: string | null; blockType: string }
						| { __typename?: "IntegerBlock"; id?: string | null; blockType: string }
						| { __typename?: "InternalLinkBlock"; id?: string | null; blockType: string }
						| { __typename?: "ListBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "LogoListBlock";
								id?: string | null;
								blockType: string;
								title: string;
								logos: Array<{
									__typename?: "ImageObjectType";
									id: string;
									rendition?: {
										__typename?: "ImageRenditionObjectType";
										url: string;
										width: number;
										height: number;
										image: { __typename?: "ImageObjectType"; title: string };
									} | null;
								} | null>;
						  }
						| { __typename?: "PageChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "ProfileBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "ProfileListBlock";
								id?: string | null;
								blockType: string;
								intro?: string | null;
								heading: string;
								profiles?: Array<
									| { __typename?: "AccordionBlock" }
									| { __typename?: "AccordionSection" }
									| { __typename?: "BlockQuoteBlock" }
									| { __typename?: "BooleanBlock" }
									| { __typename?: "CaptionedImageBlock" }
									| { __typename?: "CharBlock" }
									| { __typename?: "CheckboxFieldBlock" }
									| { __typename?: "ChoiceBlock" }
									| { __typename?: "ChoiceFieldBlock" }
									| { __typename?: "DateBlock" }
									| { __typename?: "DateTimeBlock" }
									| { __typename?: "DecimalBlock" }
									| { __typename?: "DocumentChooserBlock" }
									| { __typename?: "EmailBlock" }
									| { __typename?: "EmbedBlock" }
									| { __typename?: "ExternalLinkBlock" }
									| { __typename?: "FeaturedContentBlock" }
									| { __typename?: "FieldBlock" }
									| { __typename?: "FileFieldBlock" }
									| { __typename?: "FloatBlock" }
									| { __typename?: "FormBlock" }
									| { __typename?: "FullWidthImageBlock" }
									| { __typename?: "ImageBlock" }
									| { __typename?: "ImageChooserBlock" }
									| { __typename?: "ImageContentBlock" }
									| { __typename?: "IntegerBlock" }
									| { __typename?: "InternalLinkBlock" }
									| { __typename?: "ListBlock" }
									| { __typename?: "LogoListBlock" }
									| { __typename?: "PageChooserBlock" }
									| {
											__typename?: "ProfileBlock";
											title: string;
											content: any;
											image: {
												__typename?: "ImageObjectType";
												rendition?: {
													__typename?: "ImageRenditionObjectType";
													url: string;
													width: number;
													height: number;
													image: { __typename?: "ImageObjectType"; title: string };
												} | null;
											};
									  }
									| { __typename?: "ProfileListBlock" }
									| { __typename?: "QuickLinksBlock" }
									| { __typename?: "QuoteBlock" }
									| { __typename?: "RawHTMLBlock" }
									| { __typename?: "RegexBlock" }
									| { __typename?: "ResourcesBlock" }
									| { __typename?: "RichTextBlock" }
									| { __typename?: "RichtextWithHeadingBlock" }
									| { __typename?: "RichtextWithImageBlock" }
									| { __typename?: "SnippetChooserBlock" }
									| { __typename?: "StatBlock" }
									| { __typename?: "StaticBlock" }
									| { __typename?: "StatsBlock" }
									| { __typename?: "StreamBlock" }
									| { __typename?: "StreamFieldBlock" }
									| { __typename?: "StructBlock" }
									| { __typename?: "TextBlock" }
									| { __typename?: "TimeBlock" }
									| { __typename?: "URLBlock" }
									| { __typename?: "VideoEmbedBlock" }
									| null
								> | null;
						  }
						| { __typename?: "QuickLinksBlock"; id?: string | null; blockType: string }
						| { __typename?: "QuoteBlock"; id?: string | null; blockType: string }
						| { __typename?: "RawHTMLBlock"; id?: string | null; blockType: string }
						| { __typename?: "RegexBlock"; id?: string | null; blockType: string }
						| { __typename?: "ResourcesBlock"; id?: string | null; blockType: string }
						| { __typename?: "RichTextBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "RichtextWithHeadingBlock";
								id?: string | null;
								blockType: string;
								heading: string;
								richtext: any;
						  }
						| {
								__typename?: "RichtextWithImageBlock";
								id?: string | null;
								blockType: string;
								imageRichtext?: any | null;
								captionedImage:
									| { __typename?: "AccordionBlock" }
									| { __typename?: "AccordionSection" }
									| { __typename?: "BlockQuoteBlock" }
									| { __typename?: "BooleanBlock" }
									| {
											__typename?: "CaptionedImageBlock";
											caption?: string | null;
											image?: {
												__typename?: "ImageObjectType";
												rendition?: {
													__typename?: "ImageRenditionObjectType";
													url: string;
													width: number;
													height: number;
													image: { __typename?: "ImageObjectType"; title: string };
												} | null;
											} | null;
									  }
									| { __typename?: "CharBlock" }
									| { __typename?: "CheckboxFieldBlock" }
									| { __typename?: "ChoiceBlock" }
									| { __typename?: "ChoiceFieldBlock" }
									| { __typename?: "DateBlock" }
									| { __typename?: "DateTimeBlock" }
									| { __typename?: "DecimalBlock" }
									| { __typename?: "DocumentChooserBlock" }
									| { __typename?: "EmailBlock" }
									| { __typename?: "EmbedBlock" }
									| { __typename?: "ExternalLinkBlock" }
									| { __typename?: "FeaturedContentBlock" }
									| { __typename?: "FieldBlock" }
									| { __typename?: "FileFieldBlock" }
									| { __typename?: "FloatBlock" }
									| { __typename?: "FormBlock" }
									| { __typename?: "FullWidthImageBlock" }
									| { __typename?: "ImageBlock" }
									| { __typename?: "ImageChooserBlock" }
									| { __typename?: "ImageContentBlock" }
									| { __typename?: "IntegerBlock" }
									| { __typename?: "InternalLinkBlock" }
									| { __typename?: "ListBlock" }
									| { __typename?: "LogoListBlock" }
									| { __typename?: "PageChooserBlock" }
									| { __typename?: "ProfileBlock" }
									| { __typename?: "ProfileListBlock" }
									| { __typename?: "QuickLinksBlock" }
									| { __typename?: "QuoteBlock" }
									| { __typename?: "RawHTMLBlock" }
									| { __typename?: "RegexBlock" }
									| { __typename?: "ResourcesBlock" }
									| { __typename?: "RichTextBlock" }
									| { __typename?: "RichtextWithHeadingBlock" }
									| { __typename?: "RichtextWithImageBlock" }
									| { __typename?: "SnippetChooserBlock" }
									| { __typename?: "StatBlock" }
									| { __typename?: "StaticBlock" }
									| { __typename?: "StatsBlock" }
									| { __typename?: "StreamBlock" }
									| { __typename?: "StreamFieldBlock" }
									| { __typename?: "StructBlock" }
									| { __typename?: "TextBlock" }
									| { __typename?: "TimeBlock" }
									| { __typename?: "URLBlock" }
									| { __typename?: "VideoEmbedBlock" };
						  }
						| { __typename?: "SnippetChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "StatBlock"; id?: string | null; blockType: string }
						| { __typename?: "StaticBlock"; id?: string | null; blockType: string }
						| { __typename?: "StatsBlock"; id?: string | null; blockType: string }
						| { __typename?: "StreamBlock"; id?: string | null; blockType: string }
						| { __typename?: "StreamFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "StructBlock"; id?: string | null; blockType: string }
						| { __typename?: "TextBlock"; id?: string | null; blockType: string }
						| { __typename?: "TimeBlock"; id?: string | null; blockType: string }
						| { __typename?: "URLBlock"; id?: string | null; blockType: string }
						| { __typename?: "VideoEmbedBlock"; id?: string | null; blockType: string; title: string; url: string }
						| null
					> | null;
			  }
			| {
					__typename?: "HomePage";
					id?: string | null;
					title: string;
					slug: string;
					url?: string | null;
					urlPath: string;
					pageType?: string | null;
					seoTitle: string;
					searchDescription?: string | null;
					path: string;
					heroTagline?: string | null;
					introText?: string | null;
					learnMoreLink?: string | null;
					learnMoreLabel?: string | null;
					searchImage?: {
						__typename?: "ImageObjectType";
						rendition?: {
							__typename?: "ImageRenditionObjectType";
							url: string;
							width: number;
							height: number;
							image: { __typename?: "ImageObjectType"; title: string };
						} | null;
					} | null;
					heroImage?: {
						__typename?: "ImageObjectType";
						rendition?: {
							__typename?: "ImageRenditionObjectType";
							url: string;
							width: number;
							height: number;
							image: { __typename?: "ImageObjectType"; title: string };
						} | null;
					} | null;
					heroLinks?: Array<
						| { __typename?: "AccordionBlock" }
						| { __typename?: "AccordionSection" }
						| { __typename?: "BlockQuoteBlock" }
						| { __typename?: "BooleanBlock" }
						| { __typename?: "CaptionedImageBlock" }
						| { __typename?: "CharBlock" }
						| { __typename?: "CheckboxFieldBlock" }
						| { __typename?: "ChoiceBlock" }
						| { __typename?: "ChoiceFieldBlock" }
						| { __typename?: "DateBlock" }
						| { __typename?: "DateTimeBlock" }
						| { __typename?: "DecimalBlock" }
						| { __typename?: "DocumentChooserBlock" }
						| { __typename?: "EmailBlock" }
						| { __typename?: "EmbedBlock" }
						| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
						| { __typename?: "FeaturedContentBlock" }
						| { __typename?: "FieldBlock" }
						| { __typename?: "FileFieldBlock" }
						| { __typename?: "FloatBlock" }
						| { __typename?: "FormBlock" }
						| { __typename?: "FullWidthImageBlock" }
						| { __typename?: "ImageBlock" }
						| { __typename?: "ImageChooserBlock" }
						| { __typename?: "ImageContentBlock" }
						| { __typename?: "IntegerBlock" }
						| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
						| { __typename?: "ListBlock" }
						| { __typename?: "LogoListBlock" }
						| { __typename?: "PageChooserBlock" }
						| { __typename?: "ProfileBlock" }
						| { __typename?: "ProfileListBlock" }
						| { __typename?: "QuickLinksBlock" }
						| { __typename?: "QuoteBlock" }
						| { __typename?: "RawHTMLBlock" }
						| { __typename?: "RegexBlock" }
						| { __typename?: "ResourcesBlock" }
						| { __typename?: "RichTextBlock" }
						| { __typename?: "RichtextWithHeadingBlock" }
						| { __typename?: "RichtextWithImageBlock" }
						| { __typename?: "SnippetChooserBlock" }
						| { __typename?: "StatBlock" }
						| { __typename?: "StaticBlock" }
						| { __typename?: "StatsBlock" }
						| { __typename?: "StreamBlock" }
						| { __typename?: "StreamFieldBlock" }
						| { __typename?: "StructBlock" }
						| { __typename?: "TextBlock" }
						| { __typename?: "TimeBlock" }
						| { __typename?: "URLBlock" }
						| { __typename?: "VideoEmbedBlock" }
						| null
					> | null;
					introLinks?: Array<
						| { __typename?: "AccordionBlock" }
						| { __typename?: "AccordionSection" }
						| { __typename?: "BlockQuoteBlock" }
						| { __typename?: "BooleanBlock" }
						| { __typename?: "CaptionedImageBlock" }
						| { __typename?: "CharBlock" }
						| { __typename?: "CheckboxFieldBlock" }
						| { __typename?: "ChoiceBlock" }
						| { __typename?: "ChoiceFieldBlock" }
						| { __typename?: "DateBlock" }
						| { __typename?: "DateTimeBlock" }
						| { __typename?: "DecimalBlock" }
						| { __typename?: "DocumentChooserBlock" }
						| { __typename?: "EmailBlock" }
						| { __typename?: "EmbedBlock" }
						| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
						| { __typename?: "FeaturedContentBlock" }
						| { __typename?: "FieldBlock" }
						| { __typename?: "FileFieldBlock" }
						| { __typename?: "FloatBlock" }
						| { __typename?: "FormBlock" }
						| { __typename?: "FullWidthImageBlock" }
						| { __typename?: "ImageBlock" }
						| { __typename?: "ImageChooserBlock" }
						| { __typename?: "ImageContentBlock" }
						| { __typename?: "IntegerBlock" }
						| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
						| { __typename?: "ListBlock" }
						| { __typename?: "LogoListBlock" }
						| { __typename?: "PageChooserBlock" }
						| { __typename?: "ProfileBlock" }
						| { __typename?: "ProfileListBlock" }
						| { __typename?: "QuickLinksBlock" }
						| { __typename?: "QuoteBlock" }
						| { __typename?: "RawHTMLBlock" }
						| { __typename?: "RegexBlock" }
						| { __typename?: "ResourcesBlock" }
						| { __typename?: "RichTextBlock" }
						| { __typename?: "RichtextWithHeadingBlock" }
						| { __typename?: "RichtextWithImageBlock" }
						| { __typename?: "SnippetChooserBlock" }
						| { __typename?: "StatBlock" }
						| { __typename?: "StaticBlock" }
						| { __typename?: "StatsBlock" }
						| { __typename?: "StreamBlock" }
						| { __typename?: "StreamFieldBlock" }
						| { __typename?: "StructBlock" }
						| { __typename?: "TextBlock" }
						| { __typename?: "TimeBlock" }
						| { __typename?: "URLBlock" }
						| { __typename?: "VideoEmbedBlock" }
						| null
					> | null;
					body?: Array<
						| { __typename?: "AccordionBlock"; id?: string | null; blockType: string }
						| { __typename?: "AccordionSection"; id?: string | null; blockType: string }
						| { __typename?: "BlockQuoteBlock"; id?: string | null; blockType: string }
						| { __typename?: "BooleanBlock"; id?: string | null; blockType: string }
						| { __typename?: "CaptionedImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "CharBlock"; id?: string | null; blockType: string }
						| { __typename?: "CheckboxFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "ChoiceBlock"; id?: string | null; blockType: string }
						| { __typename?: "ChoiceFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "DateBlock"; id?: string | null; blockType: string }
						| { __typename?: "DateTimeBlock"; id?: string | null; blockType: string }
						| { __typename?: "DecimalBlock"; id?: string | null; blockType: string }
						| { __typename?: "DocumentChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "EmailBlock"; id?: string | null; blockType: string }
						| { __typename?: "EmbedBlock"; id?: string | null; blockType: string }
						| { __typename?: "ExternalLinkBlock"; id?: string | null; blockType: string }
						| { __typename?: "FeaturedContentBlock"; id?: string | null; blockType: string }
						| { __typename?: "FieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "FileFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "FloatBlock"; id?: string | null; blockType: string }
						| { __typename?: "FormBlock"; id?: string | null; blockType: string }
						| { __typename?: "FullWidthImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "ImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "ImageChooserBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "ImageContentBlock";
								id?: string | null;
								blockType: string;
								direction: string;
								superTitle?: string | null;
								content: string;
								link?: string | null;
								linkText?: string | null;
								imageTitle?: string | null;
								contentImage: {
									__typename?: "ImageObjectType";
									rendition?: {
										__typename?: "ImageRenditionObjectType";
										url: string;
										width: number;
										height: number;
										image: { __typename?: "ImageObjectType"; title: string };
									} | null;
								};
						  }
						| { __typename?: "IntegerBlock"; id?: string | null; blockType: string }
						| { __typename?: "InternalLinkBlock"; id?: string | null; blockType: string }
						| { __typename?: "ListBlock"; id?: string | null; blockType: string }
						| { __typename?: "LogoListBlock"; id?: string | null; blockType: string }
						| { __typename?: "PageChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "ProfileBlock"; id?: string | null; blockType: string }
						| { __typename?: "ProfileListBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "QuickLinksBlock";
								id?: string | null;
								blockType: string;
								title: string;
								links?: Array<
									| { __typename?: "AccordionBlock" }
									| { __typename?: "AccordionSection" }
									| { __typename?: "BlockQuoteBlock" }
									| { __typename?: "BooleanBlock" }
									| { __typename?: "CaptionedImageBlock" }
									| { __typename?: "CharBlock" }
									| { __typename?: "CheckboxFieldBlock" }
									| { __typename?: "ChoiceBlock" }
									| { __typename?: "ChoiceFieldBlock" }
									| { __typename?: "DateBlock" }
									| { __typename?: "DateTimeBlock" }
									| { __typename?: "DecimalBlock" }
									| { __typename?: "DocumentChooserBlock" }
									| { __typename?: "EmailBlock" }
									| { __typename?: "EmbedBlock" }
									| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
									| { __typename?: "FeaturedContentBlock" }
									| { __typename?: "FieldBlock" }
									| { __typename?: "FileFieldBlock" }
									| { __typename?: "FloatBlock" }
									| { __typename?: "FormBlock" }
									| { __typename?: "FullWidthImageBlock" }
									| { __typename?: "ImageBlock" }
									| { __typename?: "ImageChooserBlock" }
									| { __typename?: "ImageContentBlock" }
									| { __typename?: "IntegerBlock" }
									| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
									| { __typename?: "ListBlock" }
									| { __typename?: "LogoListBlock" }
									| { __typename?: "PageChooserBlock" }
									| { __typename?: "ProfileBlock" }
									| { __typename?: "ProfileListBlock" }
									| { __typename?: "QuickLinksBlock" }
									| { __typename?: "QuoteBlock" }
									| { __typename?: "RawHTMLBlock" }
									| { __typename?: "RegexBlock" }
									| { __typename?: "ResourcesBlock" }
									| { __typename?: "RichTextBlock" }
									| { __typename?: "RichtextWithHeadingBlock" }
									| { __typename?: "RichtextWithImageBlock" }
									| { __typename?: "SnippetChooserBlock" }
									| { __typename?: "StatBlock" }
									| { __typename?: "StaticBlock" }
									| { __typename?: "StatsBlock" }
									| { __typename?: "StreamBlock" }
									| { __typename?: "StreamFieldBlock" }
									| { __typename?: "StructBlock" }
									| { __typename?: "TextBlock" }
									| { __typename?: "TimeBlock" }
									| { __typename?: "URLBlock" }
									| { __typename?: "VideoEmbedBlock" }
									| null
								> | null;
						  }
						| { __typename?: "QuoteBlock"; id?: string | null; blockType: string }
						| { __typename?: "RawHTMLBlock"; id?: string | null; blockType: string }
						| { __typename?: "RegexBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "ResourcesBlock";
								id?: string | null;
								blockType: string;
								featured?: boolean | null;
								resourcesTitle: string;
								resources: Array<{
									__typename?: "Resource";
									id?: string | null;
									title: string;
									resourceType: string;
									url: string;
									image?: {
										__typename?: "ImageObjectType";
										rendition?: {
											__typename?: "ImageRenditionObjectType";
											url: string;
											width: number;
											height: number;
											image: { __typename?: "ImageObjectType"; title: string };
										} | null;
									} | null;
								} | null>;
						  }
						| { __typename?: "RichTextBlock"; id?: string | null; blockType: string }
						| { __typename?: "RichtextWithHeadingBlock"; id?: string | null; blockType: string }
						| { __typename?: "RichtextWithImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "SnippetChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "StatBlock"; id?: string | null; blockType: string }
						| { __typename?: "StaticBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "StatsBlock";
								id?: string | null;
								blockType: string;
								statsTitle: string;
								statsImage: {
									__typename?: "ImageObjectType";
									rendition?: {
										__typename?: "ImageRenditionObjectType";
										url: string;
										width: number;
										height: number;
										image: { __typename?: "ImageObjectType"; title: string };
									} | null;
								};
								stats?: Array<
									| { __typename?: "AccordionBlock" }
									| { __typename?: "AccordionSection" }
									| { __typename?: "BlockQuoteBlock" }
									| { __typename?: "BooleanBlock" }
									| { __typename?: "CaptionedImageBlock" }
									| { __typename?: "CharBlock" }
									| { __typename?: "CheckboxFieldBlock" }
									| { __typename?: "ChoiceBlock" }
									| { __typename?: "ChoiceFieldBlock" }
									| { __typename?: "DateBlock" }
									| { __typename?: "DateTimeBlock" }
									| { __typename?: "DecimalBlock" }
									| { __typename?: "DocumentChooserBlock" }
									| { __typename?: "EmailBlock" }
									| { __typename?: "EmbedBlock" }
									| { __typename?: "ExternalLinkBlock" }
									| { __typename?: "FeaturedContentBlock" }
									| { __typename?: "FieldBlock" }
									| { __typename?: "FileFieldBlock" }
									| { __typename?: "FloatBlock" }
									| { __typename?: "FormBlock" }
									| { __typename?: "FullWidthImageBlock" }
									| { __typename?: "ImageBlock" }
									| { __typename?: "ImageChooserBlock" }
									| { __typename?: "ImageContentBlock" }
									| { __typename?: "IntegerBlock" }
									| { __typename?: "InternalLinkBlock" }
									| { __typename?: "ListBlock" }
									| { __typename?: "LogoListBlock" }
									| { __typename?: "PageChooserBlock" }
									| { __typename?: "ProfileBlock" }
									| { __typename?: "ProfileListBlock" }
									| { __typename?: "QuickLinksBlock" }
									| { __typename?: "QuoteBlock" }
									| { __typename?: "RawHTMLBlock" }
									| { __typename?: "RegexBlock" }
									| { __typename?: "ResourcesBlock" }
									| { __typename?: "RichTextBlock" }
									| { __typename?: "RichtextWithHeadingBlock" }
									| { __typename?: "RichtextWithImageBlock" }
									| { __typename?: "SnippetChooserBlock" }
									| { __typename?: "StatBlock"; stat: string; statDescription: string }
									| { __typename?: "StaticBlock" }
									| { __typename?: "StatsBlock" }
									| { __typename?: "StreamBlock" }
									| { __typename?: "StreamFieldBlock" }
									| { __typename?: "StructBlock" }
									| { __typename?: "TextBlock" }
									| { __typename?: "TimeBlock" }
									| { __typename?: "URLBlock" }
									| { __typename?: "VideoEmbedBlock" }
									| null
								> | null;
						  }
						| { __typename?: "StreamBlock"; id?: string | null; blockType: string }
						| { __typename?: "StreamFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "StructBlock"; id?: string | null; blockType: string }
						| { __typename?: "TextBlock"; id?: string | null; blockType: string }
						| { __typename?: "TimeBlock"; id?: string | null; blockType: string }
						| { __typename?: "URLBlock"; id?: string | null; blockType: string }
						| { __typename?: "VideoEmbedBlock"; id?: string | null; blockType: string }
						| null
					> | null;
			  }
			| {
					__typename?: "LandingPage";
					id?: string | null;
					title: string;
					slug: string;
					url?: string | null;
					urlPath: string;
					pageType?: string | null;
					seoTitle: string;
					searchDescription?: string | null;
					path: string;
					heroTagline?: string | null;
					introText?: string | null;
					learnMoreLink?: string | null;
					learnMoreLabel?: string | null;
					searchImage?: {
						__typename?: "ImageObjectType";
						rendition?: {
							__typename?: "ImageRenditionObjectType";
							url: string;
							width: number;
							height: number;
							image: { __typename?: "ImageObjectType"; title: string };
						} | null;
					} | null;
					heroImage?: {
						__typename?: "ImageObjectType";
						rendition?: {
							__typename?: "ImageRenditionObjectType";
							url: string;
							width: number;
							height: number;
							image: { __typename?: "ImageObjectType"; title: string };
						} | null;
					} | null;
					heroLinks?: Array<
						| { __typename?: "AccordionBlock" }
						| { __typename?: "AccordionSection" }
						| { __typename?: "BlockQuoteBlock" }
						| { __typename?: "BooleanBlock" }
						| { __typename?: "CaptionedImageBlock" }
						| { __typename?: "CharBlock" }
						| { __typename?: "CheckboxFieldBlock" }
						| { __typename?: "ChoiceBlock" }
						| { __typename?: "ChoiceFieldBlock" }
						| { __typename?: "DateBlock" }
						| { __typename?: "DateTimeBlock" }
						| { __typename?: "DecimalBlock" }
						| { __typename?: "DocumentChooserBlock" }
						| { __typename?: "EmailBlock" }
						| { __typename?: "EmbedBlock" }
						| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
						| { __typename?: "FeaturedContentBlock" }
						| { __typename?: "FieldBlock" }
						| { __typename?: "FileFieldBlock" }
						| { __typename?: "FloatBlock" }
						| { __typename?: "FormBlock" }
						| { __typename?: "FullWidthImageBlock" }
						| { __typename?: "ImageBlock" }
						| { __typename?: "ImageChooserBlock" }
						| { __typename?: "ImageContentBlock" }
						| { __typename?: "IntegerBlock" }
						| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
						| { __typename?: "ListBlock" }
						| { __typename?: "LogoListBlock" }
						| { __typename?: "PageChooserBlock" }
						| { __typename?: "ProfileBlock" }
						| { __typename?: "ProfileListBlock" }
						| { __typename?: "QuickLinksBlock" }
						| { __typename?: "QuoteBlock" }
						| { __typename?: "RawHTMLBlock" }
						| { __typename?: "RegexBlock" }
						| { __typename?: "ResourcesBlock" }
						| { __typename?: "RichTextBlock" }
						| { __typename?: "RichtextWithHeadingBlock" }
						| { __typename?: "RichtextWithImageBlock" }
						| { __typename?: "SnippetChooserBlock" }
						| { __typename?: "StatBlock" }
						| { __typename?: "StaticBlock" }
						| { __typename?: "StatsBlock" }
						| { __typename?: "StreamBlock" }
						| { __typename?: "StreamFieldBlock" }
						| { __typename?: "StructBlock" }
						| { __typename?: "TextBlock" }
						| { __typename?: "TimeBlock" }
						| { __typename?: "URLBlock" }
						| { __typename?: "VideoEmbedBlock" }
						| null
					> | null;
					introLinks?: Array<
						| { __typename?: "AccordionBlock" }
						| { __typename?: "AccordionSection" }
						| { __typename?: "BlockQuoteBlock" }
						| { __typename?: "BooleanBlock" }
						| { __typename?: "CaptionedImageBlock" }
						| { __typename?: "CharBlock" }
						| { __typename?: "CheckboxFieldBlock" }
						| { __typename?: "ChoiceBlock" }
						| { __typename?: "ChoiceFieldBlock" }
						| { __typename?: "DateBlock" }
						| { __typename?: "DateTimeBlock" }
						| { __typename?: "DecimalBlock" }
						| { __typename?: "DocumentChooserBlock" }
						| { __typename?: "EmailBlock" }
						| { __typename?: "EmbedBlock" }
						| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
						| { __typename?: "FeaturedContentBlock" }
						| { __typename?: "FieldBlock" }
						| { __typename?: "FileFieldBlock" }
						| { __typename?: "FloatBlock" }
						| { __typename?: "FormBlock" }
						| { __typename?: "FullWidthImageBlock" }
						| { __typename?: "ImageBlock" }
						| { __typename?: "ImageChooserBlock" }
						| { __typename?: "ImageContentBlock" }
						| { __typename?: "IntegerBlock" }
						| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
						| { __typename?: "ListBlock" }
						| { __typename?: "LogoListBlock" }
						| { __typename?: "PageChooserBlock" }
						| { __typename?: "ProfileBlock" }
						| { __typename?: "ProfileListBlock" }
						| { __typename?: "QuickLinksBlock" }
						| { __typename?: "QuoteBlock" }
						| { __typename?: "RawHTMLBlock" }
						| { __typename?: "RegexBlock" }
						| { __typename?: "ResourcesBlock" }
						| { __typename?: "RichTextBlock" }
						| { __typename?: "RichtextWithHeadingBlock" }
						| { __typename?: "RichtextWithImageBlock" }
						| { __typename?: "SnippetChooserBlock" }
						| { __typename?: "StatBlock" }
						| { __typename?: "StaticBlock" }
						| { __typename?: "StatsBlock" }
						| { __typename?: "StreamBlock" }
						| { __typename?: "StreamFieldBlock" }
						| { __typename?: "StructBlock" }
						| { __typename?: "TextBlock" }
						| { __typename?: "TimeBlock" }
						| { __typename?: "URLBlock" }
						| { __typename?: "VideoEmbedBlock" }
						| null
					> | null;
					body?: Array<
						| { __typename?: "AccordionBlock"; id?: string | null; blockType: string }
						| { __typename?: "AccordionSection"; id?: string | null; blockType: string }
						| { __typename?: "BlockQuoteBlock"; id?: string | null; blockType: string }
						| { __typename?: "BooleanBlock"; id?: string | null; blockType: string }
						| { __typename?: "CaptionedImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "CharBlock"; id?: string | null; blockType: string }
						| { __typename?: "CheckboxFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "ChoiceBlock"; id?: string | null; blockType: string }
						| { __typename?: "ChoiceFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "DateBlock"; id?: string | null; blockType: string }
						| { __typename?: "DateTimeBlock"; id?: string | null; blockType: string }
						| { __typename?: "DecimalBlock"; id?: string | null; blockType: string }
						| { __typename?: "DocumentChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "EmailBlock"; id?: string | null; blockType: string }
						| { __typename?: "EmbedBlock"; id?: string | null; blockType: string }
						| { __typename?: "ExternalLinkBlock"; id?: string | null; blockType: string }
						| { __typename?: "FeaturedContentBlock"; id?: string | null; blockType: string }
						| { __typename?: "FieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "FileFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "FloatBlock"; id?: string | null; blockType: string }
						| { __typename?: "FormBlock"; id?: string | null; blockType: string }
						| { __typename?: "FullWidthImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "ImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "ImageChooserBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "ImageContentBlock";
								id?: string | null;
								blockType: string;
								direction: string;
								superTitle?: string | null;
								content: string;
								link?: string | null;
								linkText?: string | null;
								imageTitle?: string | null;
								contentImage: {
									__typename?: "ImageObjectType";
									rendition?: {
										__typename?: "ImageRenditionObjectType";
										url: string;
										width: number;
										height: number;
										image: { __typename?: "ImageObjectType"; title: string };
									} | null;
								};
						  }
						| { __typename?: "IntegerBlock"; id?: string | null; blockType: string }
						| { __typename?: "InternalLinkBlock"; id?: string | null; blockType: string }
						| { __typename?: "ListBlock"; id?: string | null; blockType: string }
						| { __typename?: "LogoListBlock"; id?: string | null; blockType: string }
						| { __typename?: "PageChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "ProfileBlock"; id?: string | null; blockType: string }
						| { __typename?: "ProfileListBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "QuickLinksBlock";
								id?: string | null;
								blockType: string;
								title: string;
								links?: Array<
									| { __typename?: "AccordionBlock" }
									| { __typename?: "AccordionSection" }
									| { __typename?: "BlockQuoteBlock" }
									| { __typename?: "BooleanBlock" }
									| { __typename?: "CaptionedImageBlock" }
									| { __typename?: "CharBlock" }
									| { __typename?: "CheckboxFieldBlock" }
									| { __typename?: "ChoiceBlock" }
									| { __typename?: "ChoiceFieldBlock" }
									| { __typename?: "DateBlock" }
									| { __typename?: "DateTimeBlock" }
									| { __typename?: "DecimalBlock" }
									| { __typename?: "DocumentChooserBlock" }
									| { __typename?: "EmailBlock" }
									| { __typename?: "EmbedBlock" }
									| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
									| { __typename?: "FeaturedContentBlock" }
									| { __typename?: "FieldBlock" }
									| { __typename?: "FileFieldBlock" }
									| { __typename?: "FloatBlock" }
									| { __typename?: "FormBlock" }
									| { __typename?: "FullWidthImageBlock" }
									| { __typename?: "ImageBlock" }
									| { __typename?: "ImageChooserBlock" }
									| { __typename?: "ImageContentBlock" }
									| { __typename?: "IntegerBlock" }
									| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
									| { __typename?: "ListBlock" }
									| { __typename?: "LogoListBlock" }
									| { __typename?: "PageChooserBlock" }
									| { __typename?: "ProfileBlock" }
									| { __typename?: "ProfileListBlock" }
									| { __typename?: "QuickLinksBlock" }
									| { __typename?: "QuoteBlock" }
									| { __typename?: "RawHTMLBlock" }
									| { __typename?: "RegexBlock" }
									| { __typename?: "ResourcesBlock" }
									| { __typename?: "RichTextBlock" }
									| { __typename?: "RichtextWithHeadingBlock" }
									| { __typename?: "RichtextWithImageBlock" }
									| { __typename?: "SnippetChooserBlock" }
									| { __typename?: "StatBlock" }
									| { __typename?: "StaticBlock" }
									| { __typename?: "StatsBlock" }
									| { __typename?: "StreamBlock" }
									| { __typename?: "StreamFieldBlock" }
									| { __typename?: "StructBlock" }
									| { __typename?: "TextBlock" }
									| { __typename?: "TimeBlock" }
									| { __typename?: "URLBlock" }
									| { __typename?: "VideoEmbedBlock" }
									| null
								> | null;
						  }
						| { __typename?: "QuoteBlock"; id?: string | null; blockType: string }
						| { __typename?: "RawHTMLBlock"; id?: string | null; blockType: string }
						| { __typename?: "RegexBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "ResourcesBlock";
								id?: string | null;
								blockType: string;
								featured?: boolean | null;
								resourcesTitle: string;
								resources: Array<{
									__typename?: "Resource";
									id?: string | null;
									title: string;
									resourceType: string;
									url: string;
									image?: {
										__typename?: "ImageObjectType";
										rendition?: {
											__typename?: "ImageRenditionObjectType";
											url: string;
											width: number;
											height: number;
											image: { __typename?: "ImageObjectType"; title: string };
										} | null;
									} | null;
								} | null>;
						  }
						| { __typename?: "RichTextBlock"; id?: string | null; blockType: string }
						| { __typename?: "RichtextWithHeadingBlock"; id?: string | null; blockType: string }
						| { __typename?: "RichtextWithImageBlock"; id?: string | null; blockType: string }
						| { __typename?: "SnippetChooserBlock"; id?: string | null; blockType: string }
						| { __typename?: "StatBlock"; id?: string | null; blockType: string }
						| { __typename?: "StaticBlock"; id?: string | null; blockType: string }
						| {
								__typename?: "StatsBlock";
								id?: string | null;
								blockType: string;
								statsTitle: string;
								statsImage: {
									__typename?: "ImageObjectType";
									rendition?: {
										__typename?: "ImageRenditionObjectType";
										url: string;
										width: number;
										height: number;
										image: { __typename?: "ImageObjectType"; title: string };
									} | null;
								};
								stats?: Array<
									| { __typename?: "AccordionBlock" }
									| { __typename?: "AccordionSection" }
									| { __typename?: "BlockQuoteBlock" }
									| { __typename?: "BooleanBlock" }
									| { __typename?: "CaptionedImageBlock" }
									| { __typename?: "CharBlock" }
									| { __typename?: "CheckboxFieldBlock" }
									| { __typename?: "ChoiceBlock" }
									| { __typename?: "ChoiceFieldBlock" }
									| { __typename?: "DateBlock" }
									| { __typename?: "DateTimeBlock" }
									| { __typename?: "DecimalBlock" }
									| { __typename?: "DocumentChooserBlock" }
									| { __typename?: "EmailBlock" }
									| { __typename?: "EmbedBlock" }
									| { __typename?: "ExternalLinkBlock" }
									| { __typename?: "FeaturedContentBlock" }
									| { __typename?: "FieldBlock" }
									| { __typename?: "FileFieldBlock" }
									| { __typename?: "FloatBlock" }
									| { __typename?: "FormBlock" }
									| { __typename?: "FullWidthImageBlock" }
									| { __typename?: "ImageBlock" }
									| { __typename?: "ImageChooserBlock" }
									| { __typename?: "ImageContentBlock" }
									| { __typename?: "IntegerBlock" }
									| { __typename?: "InternalLinkBlock" }
									| { __typename?: "ListBlock" }
									| { __typename?: "LogoListBlock" }
									| { __typename?: "PageChooserBlock" }
									| { __typename?: "ProfileBlock" }
									| { __typename?: "ProfileListBlock" }
									| { __typename?: "QuickLinksBlock" }
									| { __typename?: "QuoteBlock" }
									| { __typename?: "RawHTMLBlock" }
									| { __typename?: "RegexBlock" }
									| { __typename?: "ResourcesBlock" }
									| { __typename?: "RichTextBlock" }
									| { __typename?: "RichtextWithHeadingBlock" }
									| { __typename?: "RichtextWithImageBlock" }
									| { __typename?: "SnippetChooserBlock" }
									| { __typename?: "StatBlock"; stat: string; statDescription: string }
									| { __typename?: "StaticBlock" }
									| { __typename?: "StatsBlock" }
									| { __typename?: "StreamBlock" }
									| { __typename?: "StreamFieldBlock" }
									| { __typename?: "StructBlock" }
									| { __typename?: "TextBlock" }
									| { __typename?: "TimeBlock" }
									| { __typename?: "URLBlock" }
									| { __typename?: "VideoEmbedBlock" }
									| null
								> | null;
						  }
						| { __typename?: "StreamBlock"; id?: string | null; blockType: string }
						| { __typename?: "StreamFieldBlock"; id?: string | null; blockType: string }
						| { __typename?: "StructBlock"; id?: string | null; blockType: string }
						| { __typename?: "TextBlock"; id?: string | null; blockType: string }
						| { __typename?: "TimeBlock"; id?: string | null; blockType: string }
						| { __typename?: "URLBlock"; id?: string | null; blockType: string }
						| { __typename?: "VideoEmbedBlock"; id?: string | null; blockType: string }
						| null
					> | null;
			  }
			| {
					__typename?: "Page";
					id?: string | null;
					title: string;
					slug: string;
					url?: string | null;
					urlPath: string;
					pageType?: string | null;
					seoTitle: string;
					searchDescription?: string | null;
			  }
			| null;
	} | null;
};

export type ImageRenditionFieldsFragment = {
	__typename?: "ImageRenditionObjectType";
	url: string;
	width: number;
	height: number;
	image: { __typename?: "ImageObjectType"; title: string };
};

export type HomePageFragment = {
	__typename?: "HomePage";
	path: string;
	title: string;
	slug: string;
	seoTitle: string;
	searchDescription?: string | null;
	pageType?: string | null;
	heroTagline?: string | null;
	introText?: string | null;
	learnMoreLink?: string | null;
	learnMoreLabel?: string | null;
	searchImage?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
	heroImage?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
	heroLinks?: Array<
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| { __typename?: "CaptionedImageBlock" }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| { __typename?: "ProfileBlock" }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock" }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" }
		| null
	> | null;
	introLinks?: Array<
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| { __typename?: "CaptionedImageBlock" }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| { __typename?: "ProfileBlock" }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock" }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" }
		| null
	> | null;
	body?: Array<
		| { __typename?: "AccordionBlock"; id?: string | null; blockType: string }
		| { __typename?: "AccordionSection"; id?: string | null; blockType: string }
		| { __typename?: "BlockQuoteBlock"; id?: string | null; blockType: string }
		| { __typename?: "BooleanBlock"; id?: string | null; blockType: string }
		| { __typename?: "CaptionedImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "CharBlock"; id?: string | null; blockType: string }
		| { __typename?: "CheckboxFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "ChoiceBlock"; id?: string | null; blockType: string }
		| { __typename?: "ChoiceFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "DateBlock"; id?: string | null; blockType: string }
		| { __typename?: "DateTimeBlock"; id?: string | null; blockType: string }
		| { __typename?: "DecimalBlock"; id?: string | null; blockType: string }
		| { __typename?: "DocumentChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "EmailBlock"; id?: string | null; blockType: string }
		| { __typename?: "EmbedBlock"; id?: string | null; blockType: string }
		| { __typename?: "ExternalLinkBlock"; id?: string | null; blockType: string }
		| { __typename?: "FeaturedContentBlock"; id?: string | null; blockType: string }
		| { __typename?: "FieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "FileFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "FloatBlock"; id?: string | null; blockType: string }
		| { __typename?: "FormBlock"; id?: string | null; blockType: string }
		| { __typename?: "FullWidthImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "ImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "ImageChooserBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "ImageContentBlock";
				id?: string | null;
				blockType: string;
				direction: string;
				superTitle?: string | null;
				content: string;
				link?: string | null;
				linkText?: string | null;
				imageTitle?: string | null;
				contentImage: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				};
		  }
		| { __typename?: "IntegerBlock"; id?: string | null; blockType: string }
		| { __typename?: "InternalLinkBlock"; id?: string | null; blockType: string }
		| { __typename?: "ListBlock"; id?: string | null; blockType: string }
		| { __typename?: "LogoListBlock"; id?: string | null; blockType: string }
		| { __typename?: "PageChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "ProfileBlock"; id?: string | null; blockType: string }
		| { __typename?: "ProfileListBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "QuickLinksBlock";
				id?: string | null;
				blockType: string;
				title: string;
				links?: Array<
					| { __typename?: "AccordionBlock" }
					| { __typename?: "AccordionSection" }
					| { __typename?: "BlockQuoteBlock" }
					| { __typename?: "BooleanBlock" }
					| { __typename?: "CaptionedImageBlock" }
					| { __typename?: "CharBlock" }
					| { __typename?: "CheckboxFieldBlock" }
					| { __typename?: "ChoiceBlock" }
					| { __typename?: "ChoiceFieldBlock" }
					| { __typename?: "DateBlock" }
					| { __typename?: "DateTimeBlock" }
					| { __typename?: "DecimalBlock" }
					| { __typename?: "DocumentChooserBlock" }
					| { __typename?: "EmailBlock" }
					| { __typename?: "EmbedBlock" }
					| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
					| { __typename?: "FeaturedContentBlock" }
					| { __typename?: "FieldBlock" }
					| { __typename?: "FileFieldBlock" }
					| { __typename?: "FloatBlock" }
					| { __typename?: "FormBlock" }
					| { __typename?: "FullWidthImageBlock" }
					| { __typename?: "ImageBlock" }
					| { __typename?: "ImageChooserBlock" }
					| { __typename?: "ImageContentBlock" }
					| { __typename?: "IntegerBlock" }
					| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
					| { __typename?: "ListBlock" }
					| { __typename?: "LogoListBlock" }
					| { __typename?: "PageChooserBlock" }
					| { __typename?: "ProfileBlock" }
					| { __typename?: "ProfileListBlock" }
					| { __typename?: "QuickLinksBlock" }
					| { __typename?: "QuoteBlock" }
					| { __typename?: "RawHTMLBlock" }
					| { __typename?: "RegexBlock" }
					| { __typename?: "ResourcesBlock" }
					| { __typename?: "RichTextBlock" }
					| { __typename?: "RichtextWithHeadingBlock" }
					| { __typename?: "RichtextWithImageBlock" }
					| { __typename?: "SnippetChooserBlock" }
					| { __typename?: "StatBlock" }
					| { __typename?: "StaticBlock" }
					| { __typename?: "StatsBlock" }
					| { __typename?: "StreamBlock" }
					| { __typename?: "StreamFieldBlock" }
					| { __typename?: "StructBlock" }
					| { __typename?: "TextBlock" }
					| { __typename?: "TimeBlock" }
					| { __typename?: "URLBlock" }
					| { __typename?: "VideoEmbedBlock" }
					| null
				> | null;
		  }
		| { __typename?: "QuoteBlock"; id?: string | null; blockType: string }
		| { __typename?: "RawHTMLBlock"; id?: string | null; blockType: string }
		| { __typename?: "RegexBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "ResourcesBlock";
				id?: string | null;
				blockType: string;
				featured?: boolean | null;
				resourcesTitle: string;
				resources: Array<{
					__typename?: "Resource";
					id?: string | null;
					title: string;
					resourceType: string;
					url: string;
					image?: {
						__typename?: "ImageObjectType";
						rendition?: {
							__typename?: "ImageRenditionObjectType";
							url: string;
							width: number;
							height: number;
							image: { __typename?: "ImageObjectType"; title: string };
						} | null;
					} | null;
				} | null>;
		  }
		| { __typename?: "RichTextBlock"; id?: string | null; blockType: string }
		| { __typename?: "RichtextWithHeadingBlock"; id?: string | null; blockType: string }
		| { __typename?: "RichtextWithImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "SnippetChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "StatBlock"; id?: string | null; blockType: string }
		| { __typename?: "StaticBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "StatsBlock";
				id?: string | null;
				blockType: string;
				statsTitle: string;
				statsImage: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				};
				stats?: Array<
					| { __typename?: "AccordionBlock" }
					| { __typename?: "AccordionSection" }
					| { __typename?: "BlockQuoteBlock" }
					| { __typename?: "BooleanBlock" }
					| { __typename?: "CaptionedImageBlock" }
					| { __typename?: "CharBlock" }
					| { __typename?: "CheckboxFieldBlock" }
					| { __typename?: "ChoiceBlock" }
					| { __typename?: "ChoiceFieldBlock" }
					| { __typename?: "DateBlock" }
					| { __typename?: "DateTimeBlock" }
					| { __typename?: "DecimalBlock" }
					| { __typename?: "DocumentChooserBlock" }
					| { __typename?: "EmailBlock" }
					| { __typename?: "EmbedBlock" }
					| { __typename?: "ExternalLinkBlock" }
					| { __typename?: "FeaturedContentBlock" }
					| { __typename?: "FieldBlock" }
					| { __typename?: "FileFieldBlock" }
					| { __typename?: "FloatBlock" }
					| { __typename?: "FormBlock" }
					| { __typename?: "FullWidthImageBlock" }
					| { __typename?: "ImageBlock" }
					| { __typename?: "ImageChooserBlock" }
					| { __typename?: "ImageContentBlock" }
					| { __typename?: "IntegerBlock" }
					| { __typename?: "InternalLinkBlock" }
					| { __typename?: "ListBlock" }
					| { __typename?: "LogoListBlock" }
					| { __typename?: "PageChooserBlock" }
					| { __typename?: "ProfileBlock" }
					| { __typename?: "ProfileListBlock" }
					| { __typename?: "QuickLinksBlock" }
					| { __typename?: "QuoteBlock" }
					| { __typename?: "RawHTMLBlock" }
					| { __typename?: "RegexBlock" }
					| { __typename?: "ResourcesBlock" }
					| { __typename?: "RichTextBlock" }
					| { __typename?: "RichtextWithHeadingBlock" }
					| { __typename?: "RichtextWithImageBlock" }
					| { __typename?: "SnippetChooserBlock" }
					| { __typename?: "StatBlock"; stat: string; statDescription: string }
					| { __typename?: "StaticBlock" }
					| { __typename?: "StatsBlock" }
					| { __typename?: "StreamBlock" }
					| { __typename?: "StreamFieldBlock" }
					| { __typename?: "StructBlock" }
					| { __typename?: "TextBlock" }
					| { __typename?: "TimeBlock" }
					| { __typename?: "URLBlock" }
					| { __typename?: "VideoEmbedBlock" }
					| null
				> | null;
		  }
		| { __typename?: "StreamBlock"; id?: string | null; blockType: string }
		| { __typename?: "StreamFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "StructBlock"; id?: string | null; blockType: string }
		| { __typename?: "TextBlock"; id?: string | null; blockType: string }
		| { __typename?: "TimeBlock"; id?: string | null; blockType: string }
		| { __typename?: "URLBlock"; id?: string | null; blockType: string }
		| { __typename?: "VideoEmbedBlock"; id?: string | null; blockType: string }
		| null
	> | null;
};

export type LandingPageFragment = {
	__typename?: "LandingPage";
	path: string;
	title: string;
	slug: string;
	seoTitle: string;
	searchDescription?: string | null;
	pageType?: string | null;
	heroTagline?: string | null;
	introText?: string | null;
	learnMoreLink?: string | null;
	learnMoreLabel?: string | null;
	searchImage?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
	heroImage?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
	heroLinks?: Array<
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| { __typename?: "CaptionedImageBlock" }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| { __typename?: "ProfileBlock" }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock" }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" }
		| null
	> | null;
	introLinks?: Array<
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| { __typename?: "CaptionedImageBlock" }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| { __typename?: "ProfileBlock" }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock" }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" }
		| null
	> | null;
	body?: Array<
		| { __typename?: "AccordionBlock"; id?: string | null; blockType: string }
		| { __typename?: "AccordionSection"; id?: string | null; blockType: string }
		| { __typename?: "BlockQuoteBlock"; id?: string | null; blockType: string }
		| { __typename?: "BooleanBlock"; id?: string | null; blockType: string }
		| { __typename?: "CaptionedImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "CharBlock"; id?: string | null; blockType: string }
		| { __typename?: "CheckboxFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "ChoiceBlock"; id?: string | null; blockType: string }
		| { __typename?: "ChoiceFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "DateBlock"; id?: string | null; blockType: string }
		| { __typename?: "DateTimeBlock"; id?: string | null; blockType: string }
		| { __typename?: "DecimalBlock"; id?: string | null; blockType: string }
		| { __typename?: "DocumentChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "EmailBlock"; id?: string | null; blockType: string }
		| { __typename?: "EmbedBlock"; id?: string | null; blockType: string }
		| { __typename?: "ExternalLinkBlock"; id?: string | null; blockType: string }
		| { __typename?: "FeaturedContentBlock"; id?: string | null; blockType: string }
		| { __typename?: "FieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "FileFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "FloatBlock"; id?: string | null; blockType: string }
		| { __typename?: "FormBlock"; id?: string | null; blockType: string }
		| { __typename?: "FullWidthImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "ImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "ImageChooserBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "ImageContentBlock";
				id?: string | null;
				blockType: string;
				direction: string;
				superTitle?: string | null;
				content: string;
				link?: string | null;
				linkText?: string | null;
				imageTitle?: string | null;
				contentImage: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				};
		  }
		| { __typename?: "IntegerBlock"; id?: string | null; blockType: string }
		| { __typename?: "InternalLinkBlock"; id?: string | null; blockType: string }
		| { __typename?: "ListBlock"; id?: string | null; blockType: string }
		| { __typename?: "LogoListBlock"; id?: string | null; blockType: string }
		| { __typename?: "PageChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "ProfileBlock"; id?: string | null; blockType: string }
		| { __typename?: "ProfileListBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "QuickLinksBlock";
				id?: string | null;
				blockType: string;
				title: string;
				links?: Array<
					| { __typename?: "AccordionBlock" }
					| { __typename?: "AccordionSection" }
					| { __typename?: "BlockQuoteBlock" }
					| { __typename?: "BooleanBlock" }
					| { __typename?: "CaptionedImageBlock" }
					| { __typename?: "CharBlock" }
					| { __typename?: "CheckboxFieldBlock" }
					| { __typename?: "ChoiceBlock" }
					| { __typename?: "ChoiceFieldBlock" }
					| { __typename?: "DateBlock" }
					| { __typename?: "DateTimeBlock" }
					| { __typename?: "DecimalBlock" }
					| { __typename?: "DocumentChooserBlock" }
					| { __typename?: "EmailBlock" }
					| { __typename?: "EmbedBlock" }
					| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
					| { __typename?: "FeaturedContentBlock" }
					| { __typename?: "FieldBlock" }
					| { __typename?: "FileFieldBlock" }
					| { __typename?: "FloatBlock" }
					| { __typename?: "FormBlock" }
					| { __typename?: "FullWidthImageBlock" }
					| { __typename?: "ImageBlock" }
					| { __typename?: "ImageChooserBlock" }
					| { __typename?: "ImageContentBlock" }
					| { __typename?: "IntegerBlock" }
					| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
					| { __typename?: "ListBlock" }
					| { __typename?: "LogoListBlock" }
					| { __typename?: "PageChooserBlock" }
					| { __typename?: "ProfileBlock" }
					| { __typename?: "ProfileListBlock" }
					| { __typename?: "QuickLinksBlock" }
					| { __typename?: "QuoteBlock" }
					| { __typename?: "RawHTMLBlock" }
					| { __typename?: "RegexBlock" }
					| { __typename?: "ResourcesBlock" }
					| { __typename?: "RichTextBlock" }
					| { __typename?: "RichtextWithHeadingBlock" }
					| { __typename?: "RichtextWithImageBlock" }
					| { __typename?: "SnippetChooserBlock" }
					| { __typename?: "StatBlock" }
					| { __typename?: "StaticBlock" }
					| { __typename?: "StatsBlock" }
					| { __typename?: "StreamBlock" }
					| { __typename?: "StreamFieldBlock" }
					| { __typename?: "StructBlock" }
					| { __typename?: "TextBlock" }
					| { __typename?: "TimeBlock" }
					| { __typename?: "URLBlock" }
					| { __typename?: "VideoEmbedBlock" }
					| null
				> | null;
		  }
		| { __typename?: "QuoteBlock"; id?: string | null; blockType: string }
		| { __typename?: "RawHTMLBlock"; id?: string | null; blockType: string }
		| { __typename?: "RegexBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "ResourcesBlock";
				id?: string | null;
				blockType: string;
				featured?: boolean | null;
				resourcesTitle: string;
				resources: Array<{
					__typename?: "Resource";
					id?: string | null;
					title: string;
					resourceType: string;
					url: string;
					image?: {
						__typename?: "ImageObjectType";
						rendition?: {
							__typename?: "ImageRenditionObjectType";
							url: string;
							width: number;
							height: number;
							image: { __typename?: "ImageObjectType"; title: string };
						} | null;
					} | null;
				} | null>;
		  }
		| { __typename?: "RichTextBlock"; id?: string | null; blockType: string }
		| { __typename?: "RichtextWithHeadingBlock"; id?: string | null; blockType: string }
		| { __typename?: "RichtextWithImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "SnippetChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "StatBlock"; id?: string | null; blockType: string }
		| { __typename?: "StaticBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "StatsBlock";
				id?: string | null;
				blockType: string;
				statsTitle: string;
				statsImage: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				};
				stats?: Array<
					| { __typename?: "AccordionBlock" }
					| { __typename?: "AccordionSection" }
					| { __typename?: "BlockQuoteBlock" }
					| { __typename?: "BooleanBlock" }
					| { __typename?: "CaptionedImageBlock" }
					| { __typename?: "CharBlock" }
					| { __typename?: "CheckboxFieldBlock" }
					| { __typename?: "ChoiceBlock" }
					| { __typename?: "ChoiceFieldBlock" }
					| { __typename?: "DateBlock" }
					| { __typename?: "DateTimeBlock" }
					| { __typename?: "DecimalBlock" }
					| { __typename?: "DocumentChooserBlock" }
					| { __typename?: "EmailBlock" }
					| { __typename?: "EmbedBlock" }
					| { __typename?: "ExternalLinkBlock" }
					| { __typename?: "FeaturedContentBlock" }
					| { __typename?: "FieldBlock" }
					| { __typename?: "FileFieldBlock" }
					| { __typename?: "FloatBlock" }
					| { __typename?: "FormBlock" }
					| { __typename?: "FullWidthImageBlock" }
					| { __typename?: "ImageBlock" }
					| { __typename?: "ImageChooserBlock" }
					| { __typename?: "ImageContentBlock" }
					| { __typename?: "IntegerBlock" }
					| { __typename?: "InternalLinkBlock" }
					| { __typename?: "ListBlock" }
					| { __typename?: "LogoListBlock" }
					| { __typename?: "PageChooserBlock" }
					| { __typename?: "ProfileBlock" }
					| { __typename?: "ProfileListBlock" }
					| { __typename?: "QuickLinksBlock" }
					| { __typename?: "QuoteBlock" }
					| { __typename?: "RawHTMLBlock" }
					| { __typename?: "RegexBlock" }
					| { __typename?: "ResourcesBlock" }
					| { __typename?: "RichTextBlock" }
					| { __typename?: "RichtextWithHeadingBlock" }
					| { __typename?: "RichtextWithImageBlock" }
					| { __typename?: "SnippetChooserBlock" }
					| { __typename?: "StatBlock"; stat: string; statDescription: string }
					| { __typename?: "StaticBlock" }
					| { __typename?: "StatsBlock" }
					| { __typename?: "StreamBlock" }
					| { __typename?: "StreamFieldBlock" }
					| { __typename?: "StructBlock" }
					| { __typename?: "TextBlock" }
					| { __typename?: "TimeBlock" }
					| { __typename?: "URLBlock" }
					| { __typename?: "VideoEmbedBlock" }
					| null
				> | null;
		  }
		| { __typename?: "StreamBlock"; id?: string | null; blockType: string }
		| { __typename?: "StreamFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "StructBlock"; id?: string | null; blockType: string }
		| { __typename?: "TextBlock"; id?: string | null; blockType: string }
		| { __typename?: "TimeBlock"; id?: string | null; blockType: string }
		| { __typename?: "URLBlock"; id?: string | null; blockType: string }
		| { __typename?: "VideoEmbedBlock"; id?: string | null; blockType: string }
		| null
	> | null;
};

export type ContentPageFragment = {
	__typename?: "ContentPage";
	searchImage?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
	heroImage?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
	body?: Array<
		| { __typename?: "AccordionBlock"; id?: string | null; blockType: string }
		| { __typename?: "AccordionSection"; id?: string | null; blockType: string }
		| { __typename?: "BlockQuoteBlock"; id?: string | null; blockType: string }
		| { __typename?: "BooleanBlock"; id?: string | null; blockType: string }
		| { __typename?: "CaptionedImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "CharBlock"; id?: string | null; blockType: string }
		| { __typename?: "CheckboxFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "ChoiceBlock"; id?: string | null; blockType: string }
		| { __typename?: "ChoiceFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "DateBlock"; id?: string | null; blockType: string }
		| { __typename?: "DateTimeBlock"; id?: string | null; blockType: string }
		| { __typename?: "DecimalBlock"; id?: string | null; blockType: string }
		| { __typename?: "DocumentChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "EmailBlock"; id?: string | null; blockType: string }
		| { __typename?: "EmbedBlock"; id?: string | null; blockType: string }
		| { __typename?: "ExternalLinkBlock"; id?: string | null; blockType: string }
		| { __typename?: "FeaturedContentBlock"; id?: string | null; blockType: string }
		| { __typename?: "FieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "FileFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "FloatBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "FormBlock";
				formTitle: string;
				emailTo: string;
				thankYouMessage: string;
				id?: string | null;
				blockType: string;
				formFields?: Array<
					| { __typename?: "AccordionBlock" }
					| { __typename?: "AccordionSection" }
					| { __typename?: "BlockQuoteBlock" }
					| { __typename?: "BooleanBlock" }
					| { __typename?: "CaptionedImageBlock" }
					| { __typename?: "CharBlock" }
					| {
							__typename?: "CheckboxFieldBlock";
							fieldLabel: string;
							fieldName: string;
							isRequired: boolean;
							helpText?: string | null;
					  }
					| { __typename?: "ChoiceBlock" }
					| {
							__typename?: "ChoiceFieldBlock";
							fieldLabel: string;
							fieldName: string;
							fieldType: string;
							isRequired: boolean;
							choices: Array<string | null>;
							helpText?: string | null;
					  }
					| { __typename?: "DateBlock" }
					| { __typename?: "DateTimeBlock" }
					| { __typename?: "DecimalBlock" }
					| { __typename?: "DocumentChooserBlock" }
					| { __typename?: "EmailBlock" }
					| { __typename?: "EmbedBlock" }
					| { __typename?: "ExternalLinkBlock" }
					| { __typename?: "FeaturedContentBlock" }
					| {
							__typename?: "FieldBlock";
							fieldLabel: string;
							fieldName: string;
							fieldType: string;
							isRequired: boolean;
							placeholder?: string | null;
							defaultValue?: string | null;
							helpText?: string | null;
					  }
					| {
							__typename?: "FileFieldBlock";
							fieldLabel: string;
							fieldName: string;
							helpText?: string | null;
							isRequired: boolean;
					  }
					| { __typename?: "FloatBlock" }
					| { __typename?: "FormBlock" }
					| { __typename?: "FullWidthImageBlock" }
					| { __typename?: "ImageBlock" }
					| { __typename?: "ImageChooserBlock" }
					| { __typename?: "ImageContentBlock" }
					| { __typename?: "IntegerBlock" }
					| { __typename?: "InternalLinkBlock" }
					| { __typename?: "ListBlock" }
					| { __typename?: "LogoListBlock" }
					| { __typename?: "PageChooserBlock" }
					| { __typename?: "ProfileBlock" }
					| { __typename?: "ProfileListBlock" }
					| { __typename?: "QuickLinksBlock" }
					| { __typename?: "QuoteBlock" }
					| { __typename?: "RawHTMLBlock" }
					| { __typename?: "RegexBlock" }
					| { __typename?: "ResourcesBlock" }
					| { __typename?: "RichTextBlock" }
					| { __typename?: "RichtextWithHeadingBlock" }
					| { __typename?: "RichtextWithImageBlock" }
					| { __typename?: "SnippetChooserBlock" }
					| { __typename?: "StatBlock" }
					| { __typename?: "StaticBlock" }
					| { __typename?: "StatsBlock" }
					| { __typename?: "StreamBlock" }
					| { __typename?: "StreamFieldBlock" }
					| { __typename?: "StructBlock" }
					| { __typename?: "TextBlock" }
					| { __typename?: "TimeBlock" }
					| { __typename?: "URLBlock" }
					| { __typename?: "VideoEmbedBlock" }
					| null
				> | null;
		  }
		| {
				__typename?: "FullWidthImageBlock";
				id?: string | null;
				blockType: string;
				captionedImage:
					| { __typename?: "AccordionBlock" }
					| { __typename?: "AccordionSection" }
					| { __typename?: "BlockQuoteBlock" }
					| { __typename?: "BooleanBlock" }
					| {
							__typename?: "CaptionedImageBlock";
							caption?: string | null;
							image?: {
								__typename?: "ImageObjectType";
								rendition?: {
									__typename?: "ImageRenditionObjectType";
									url: string;
									width: number;
									height: number;
									image: { __typename?: "ImageObjectType"; title: string };
								} | null;
							} | null;
					  }
					| { __typename?: "CharBlock" }
					| { __typename?: "CheckboxFieldBlock" }
					| { __typename?: "ChoiceBlock" }
					| { __typename?: "ChoiceFieldBlock" }
					| { __typename?: "DateBlock" }
					| { __typename?: "DateTimeBlock" }
					| { __typename?: "DecimalBlock" }
					| { __typename?: "DocumentChooserBlock" }
					| { __typename?: "EmailBlock" }
					| { __typename?: "EmbedBlock" }
					| { __typename?: "ExternalLinkBlock" }
					| { __typename?: "FeaturedContentBlock" }
					| { __typename?: "FieldBlock" }
					| { __typename?: "FileFieldBlock" }
					| { __typename?: "FloatBlock" }
					| { __typename?: "FormBlock" }
					| { __typename?: "FullWidthImageBlock" }
					| { __typename?: "ImageBlock" }
					| { __typename?: "ImageChooserBlock" }
					| { __typename?: "ImageContentBlock" }
					| { __typename?: "IntegerBlock" }
					| { __typename?: "InternalLinkBlock" }
					| { __typename?: "ListBlock" }
					| { __typename?: "LogoListBlock" }
					| { __typename?: "PageChooserBlock" }
					| { __typename?: "ProfileBlock" }
					| { __typename?: "ProfileListBlock" }
					| { __typename?: "QuickLinksBlock" }
					| { __typename?: "QuoteBlock" }
					| { __typename?: "RawHTMLBlock" }
					| { __typename?: "RegexBlock" }
					| { __typename?: "ResourcesBlock" }
					| { __typename?: "RichTextBlock" }
					| { __typename?: "RichtextWithHeadingBlock" }
					| { __typename?: "RichtextWithImageBlock" }
					| { __typename?: "SnippetChooserBlock" }
					| { __typename?: "StatBlock" }
					| { __typename?: "StaticBlock" }
					| { __typename?: "StatsBlock" }
					| { __typename?: "StreamBlock" }
					| { __typename?: "StreamFieldBlock" }
					| { __typename?: "StructBlock" }
					| { __typename?: "TextBlock" }
					| { __typename?: "TimeBlock" }
					| { __typename?: "URLBlock" }
					| { __typename?: "VideoEmbedBlock" };
		  }
		| { __typename?: "ImageBlock"; id?: string | null; blockType: string }
		| { __typename?: "ImageChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "ImageContentBlock"; id?: string | null; blockType: string }
		| { __typename?: "IntegerBlock"; id?: string | null; blockType: string }
		| { __typename?: "InternalLinkBlock"; id?: string | null; blockType: string }
		| { __typename?: "ListBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "LogoListBlock";
				id?: string | null;
				blockType: string;
				title: string;
				logos: Array<{
					__typename?: "ImageObjectType";
					id: string;
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				} | null>;
		  }
		| { __typename?: "PageChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "ProfileBlock"; id?: string | null; blockType: string }
		| {
				__typename?: "ProfileListBlock";
				id?: string | null;
				blockType: string;
				intro?: string | null;
				heading: string;
				profiles?: Array<
					| { __typename?: "AccordionBlock" }
					| { __typename?: "AccordionSection" }
					| { __typename?: "BlockQuoteBlock" }
					| { __typename?: "BooleanBlock" }
					| { __typename?: "CaptionedImageBlock" }
					| { __typename?: "CharBlock" }
					| { __typename?: "CheckboxFieldBlock" }
					| { __typename?: "ChoiceBlock" }
					| { __typename?: "ChoiceFieldBlock" }
					| { __typename?: "DateBlock" }
					| { __typename?: "DateTimeBlock" }
					| { __typename?: "DecimalBlock" }
					| { __typename?: "DocumentChooserBlock" }
					| { __typename?: "EmailBlock" }
					| { __typename?: "EmbedBlock" }
					| { __typename?: "ExternalLinkBlock" }
					| { __typename?: "FeaturedContentBlock" }
					| { __typename?: "FieldBlock" }
					| { __typename?: "FileFieldBlock" }
					| { __typename?: "FloatBlock" }
					| { __typename?: "FormBlock" }
					| { __typename?: "FullWidthImageBlock" }
					| { __typename?: "ImageBlock" }
					| { __typename?: "ImageChooserBlock" }
					| { __typename?: "ImageContentBlock" }
					| { __typename?: "IntegerBlock" }
					| { __typename?: "InternalLinkBlock" }
					| { __typename?: "ListBlock" }
					| { __typename?: "LogoListBlock" }
					| { __typename?: "PageChooserBlock" }
					| {
							__typename?: "ProfileBlock";
							title: string;
							content: any;
							image: {
								__typename?: "ImageObjectType";
								rendition?: {
									__typename?: "ImageRenditionObjectType";
									url: string;
									width: number;
									height: number;
									image: { __typename?: "ImageObjectType"; title: string };
								} | null;
							};
					  }
					| { __typename?: "ProfileListBlock" }
					| { __typename?: "QuickLinksBlock" }
					| { __typename?: "QuoteBlock" }
					| { __typename?: "RawHTMLBlock" }
					| { __typename?: "RegexBlock" }
					| { __typename?: "ResourcesBlock" }
					| { __typename?: "RichTextBlock" }
					| { __typename?: "RichtextWithHeadingBlock" }
					| { __typename?: "RichtextWithImageBlock" }
					| { __typename?: "SnippetChooserBlock" }
					| { __typename?: "StatBlock" }
					| { __typename?: "StaticBlock" }
					| { __typename?: "StatsBlock" }
					| { __typename?: "StreamBlock" }
					| { __typename?: "StreamFieldBlock" }
					| { __typename?: "StructBlock" }
					| { __typename?: "TextBlock" }
					| { __typename?: "TimeBlock" }
					| { __typename?: "URLBlock" }
					| { __typename?: "VideoEmbedBlock" }
					| null
				> | null;
		  }
		| { __typename?: "QuickLinksBlock"; id?: string | null; blockType: string }
		| { __typename?: "QuoteBlock"; id?: string | null; blockType: string }
		| { __typename?: "RawHTMLBlock"; id?: string | null; blockType: string }
		| { __typename?: "RegexBlock"; id?: string | null; blockType: string }
		| { __typename?: "ResourcesBlock"; id?: string | null; blockType: string }
		| { __typename?: "RichTextBlock"; id?: string | null; blockType: string }
		| { __typename?: "RichtextWithHeadingBlock"; id?: string | null; blockType: string; heading: string; richtext: any }
		| {
				__typename?: "RichtextWithImageBlock";
				id?: string | null;
				blockType: string;
				imageRichtext?: any | null;
				captionedImage:
					| { __typename?: "AccordionBlock" }
					| { __typename?: "AccordionSection" }
					| { __typename?: "BlockQuoteBlock" }
					| { __typename?: "BooleanBlock" }
					| {
							__typename?: "CaptionedImageBlock";
							caption?: string | null;
							image?: {
								__typename?: "ImageObjectType";
								rendition?: {
									__typename?: "ImageRenditionObjectType";
									url: string;
									width: number;
									height: number;
									image: { __typename?: "ImageObjectType"; title: string };
								} | null;
							} | null;
					  }
					| { __typename?: "CharBlock" }
					| { __typename?: "CheckboxFieldBlock" }
					| { __typename?: "ChoiceBlock" }
					| { __typename?: "ChoiceFieldBlock" }
					| { __typename?: "DateBlock" }
					| { __typename?: "DateTimeBlock" }
					| { __typename?: "DecimalBlock" }
					| { __typename?: "DocumentChooserBlock" }
					| { __typename?: "EmailBlock" }
					| { __typename?: "EmbedBlock" }
					| { __typename?: "ExternalLinkBlock" }
					| { __typename?: "FeaturedContentBlock" }
					| { __typename?: "FieldBlock" }
					| { __typename?: "FileFieldBlock" }
					| { __typename?: "FloatBlock" }
					| { __typename?: "FormBlock" }
					| { __typename?: "FullWidthImageBlock" }
					| { __typename?: "ImageBlock" }
					| { __typename?: "ImageChooserBlock" }
					| { __typename?: "ImageContentBlock" }
					| { __typename?: "IntegerBlock" }
					| { __typename?: "InternalLinkBlock" }
					| { __typename?: "ListBlock" }
					| { __typename?: "LogoListBlock" }
					| { __typename?: "PageChooserBlock" }
					| { __typename?: "ProfileBlock" }
					| { __typename?: "ProfileListBlock" }
					| { __typename?: "QuickLinksBlock" }
					| { __typename?: "QuoteBlock" }
					| { __typename?: "RawHTMLBlock" }
					| { __typename?: "RegexBlock" }
					| { __typename?: "ResourcesBlock" }
					| { __typename?: "RichTextBlock" }
					| { __typename?: "RichtextWithHeadingBlock" }
					| { __typename?: "RichtextWithImageBlock" }
					| { __typename?: "SnippetChooserBlock" }
					| { __typename?: "StatBlock" }
					| { __typename?: "StaticBlock" }
					| { __typename?: "StatsBlock" }
					| { __typename?: "StreamBlock" }
					| { __typename?: "StreamFieldBlock" }
					| { __typename?: "StructBlock" }
					| { __typename?: "TextBlock" }
					| { __typename?: "TimeBlock" }
					| { __typename?: "URLBlock" }
					| { __typename?: "VideoEmbedBlock" };
		  }
		| { __typename?: "SnippetChooserBlock"; id?: string | null; blockType: string }
		| { __typename?: "StatBlock"; id?: string | null; blockType: string }
		| { __typename?: "StaticBlock"; id?: string | null; blockType: string }
		| { __typename?: "StatsBlock"; id?: string | null; blockType: string }
		| { __typename?: "StreamBlock"; id?: string | null; blockType: string }
		| { __typename?: "StreamFieldBlock"; id?: string | null; blockType: string }
		| { __typename?: "StructBlock"; id?: string | null; blockType: string }
		| { __typename?: "TextBlock"; id?: string | null; blockType: string }
		| { __typename?: "TimeBlock"; id?: string | null; blockType: string }
		| { __typename?: "URLBlock"; id?: string | null; blockType: string }
		| { __typename?: "VideoEmbedBlock"; id?: string | null; blockType: string; title: string; url: string }
		| null
	> | null;
};

export type CaptionedImageFragment = {
	__typename?: "CaptionedImageBlock";
	caption?: string | null;
	image?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
};

export type RichtextWithHeadingFragment = { __typename?: "RichtextWithHeadingBlock"; heading: string; richtext: any };

export type VideoEmbedBlockFragment = { __typename?: "VideoEmbedBlock"; title: string; url: string };

export type RichtextWithImageFragment = {
	__typename?: "RichtextWithImageBlock";
	imageRichtext?: any | null;
	captionedImage:
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| {
				__typename?: "CaptionedImageBlock";
				caption?: string | null;
				image?: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				} | null;
		  }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock" }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock" }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| { __typename?: "ProfileBlock" }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock" }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" };
};

export type FullWidthImageFragment = {
	__typename?: "FullWidthImageBlock";
	captionedImage:
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| {
				__typename?: "CaptionedImageBlock";
				caption?: string | null;
				image?: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				} | null;
		  }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock" }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock" }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| { __typename?: "ProfileBlock" }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock" }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" };
};

export type ProfileListFragment = {
	__typename?: "ProfileListBlock";
	intro?: string | null;
	heading: string;
	profiles?: Array<
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| { __typename?: "CaptionedImageBlock" }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock" }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock" }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| {
				__typename?: "ProfileBlock";
				title: string;
				content: any;
				image: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				};
		  }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock" }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" }
		| null
	> | null;
};

export type ProfileFragment = {
	__typename?: "ProfileBlock";
	title: string;
	content: any;
	image: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	};
};

export type ImageContentFragment = {
	__typename?: "ImageContentBlock";
	direction: string;
	superTitle?: string | null;
	content: string;
	link?: string | null;
	linkText?: string | null;
	imageTitle?: string | null;
	contentImage: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	};
};

export type ResourcesBlockFragment = {
	__typename?: "ResourcesBlock";
	featured?: boolean | null;
	resourcesTitle: string;
	resources: Array<{
		__typename?: "Resource";
		id?: string | null;
		title: string;
		resourceType: string;
		url: string;
		image?: {
			__typename?: "ImageObjectType";
			rendition?: {
				__typename?: "ImageRenditionObjectType";
				url: string;
				width: number;
				height: number;
				image: { __typename?: "ImageObjectType"; title: string };
			} | null;
		} | null;
	} | null>;
};

export type ResourceFragment = {
	__typename?: "Resource";
	id?: string | null;
	title: string;
	resourceType: string;
	url: string;
	image?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
};

export type StatsBlockFragment = {
	__typename?: "StatsBlock";
	statsTitle: string;
	statsImage: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	};
	stats?: Array<
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| { __typename?: "CaptionedImageBlock" }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock" }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock" }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| { __typename?: "ProfileBlock" }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock"; stat: string; statDescription: string }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" }
		| null
	> | null;
};

export type StatBlockFragment = { __typename?: "StatBlock"; stat: string; statDescription: string };

export type LogoListFragment = {
	__typename?: "LogoListBlock";
	title: string;
	logos: Array<{
		__typename?: "ImageObjectType";
		id: string;
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null>;
};

export type QuickLinksFragment = {
	__typename?: "QuickLinksBlock";
	id?: string | null;
	title: string;
	links?: Array<
		| { __typename?: "AccordionBlock" }
		| { __typename?: "AccordionSection" }
		| { __typename?: "BlockQuoteBlock" }
		| { __typename?: "BooleanBlock" }
		| { __typename?: "CaptionedImageBlock" }
		| { __typename?: "CharBlock" }
		| { __typename?: "CheckboxFieldBlock" }
		| { __typename?: "ChoiceBlock" }
		| { __typename?: "ChoiceFieldBlock" }
		| { __typename?: "DateBlock" }
		| { __typename?: "DateTimeBlock" }
		| { __typename?: "DecimalBlock" }
		| { __typename?: "DocumentChooserBlock" }
		| { __typename?: "EmailBlock" }
		| { __typename?: "EmbedBlock" }
		| { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "FeaturedContentBlock" }
		| { __typename?: "FieldBlock" }
		| { __typename?: "FileFieldBlock" }
		| { __typename?: "FloatBlock" }
		| { __typename?: "FormBlock" }
		| { __typename?: "FullWidthImageBlock" }
		| { __typename?: "ImageBlock" }
		| { __typename?: "ImageChooserBlock" }
		| { __typename?: "ImageContentBlock" }
		| { __typename?: "IntegerBlock" }
		| { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string }
		| { __typename?: "ListBlock" }
		| { __typename?: "LogoListBlock" }
		| { __typename?: "PageChooserBlock" }
		| { __typename?: "ProfileBlock" }
		| { __typename?: "ProfileListBlock" }
		| { __typename?: "QuickLinksBlock" }
		| { __typename?: "QuoteBlock" }
		| { __typename?: "RawHTMLBlock" }
		| { __typename?: "RegexBlock" }
		| { __typename?: "ResourcesBlock" }
		| { __typename?: "RichTextBlock" }
		| { __typename?: "RichtextWithHeadingBlock" }
		| { __typename?: "RichtextWithImageBlock" }
		| { __typename?: "SnippetChooserBlock" }
		| { __typename?: "StatBlock" }
		| { __typename?: "StaticBlock" }
		| { __typename?: "StatsBlock" }
		| { __typename?: "StreamBlock" }
		| { __typename?: "StreamFieldBlock" }
		| { __typename?: "StructBlock" }
		| { __typename?: "TextBlock" }
		| { __typename?: "TimeBlock" }
		| { __typename?: "URLBlock" }
		| { __typename?: "VideoEmbedBlock" }
		| null
	> | null;
};

export type GetPreviewPathQueryVariables = Exact<{
	token?: InputMaybe<Scalars["String"]>;
	contentType?: InputMaybe<Scalars["String"]>;
}>;

export type GetPreviewPathQuery = {
	__typename?: "Query";
	page?:
		| { __typename?: "ContactPage"; urlPath: string }
		| { __typename?: "ContentPage"; urlPath: string }
		| { __typename?: "HomePage"; urlPath: string }
		| { __typename?: "LandingPage"; urlPath: string }
		| { __typename?: "Page"; urlPath: string }
		| null;
};

export type ResourceNodeFragment = {
	__typename?: "ResourceNode";
	id: string;
	title: string;
	resourceType?: string | null;
	url?: string | null;
	image?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
};

export type SearchResourcesQueryVariables = Exact<{
	query: Scalars["String"];
}>;

export type SearchResourcesQuery = {
	__typename?: "Query";
	resources?: Array<{
		__typename?: "ResourceNode";
		id: string;
		title: string;
		resourceType?: string | null;
		url?: string | null;
		image?: {
			__typename?: "ImageObjectType";
			rendition?: {
				__typename?: "ImageRenditionObjectType";
				url: string;
				width: number;
				height: number;
				image: { __typename?: "ImageObjectType"; title: string };
			} | null;
		} | null;
	} | null> | null;
};

export const ImageRenditionFieldsFragmentDoc = gql`
	fragment imageRenditionFields on ImageRenditionObjectType {
		url
		width
		height
		image {
			title
		}
	}
`;
export const ExternalFragmentDoc = gql`
	fragment External on ExternalLinkBlock {
		id
		href
		text
	}
`;
export const InternalFragmentDoc = gql`
	fragment Internal on InternalLinkBlock {
		id
		href
		text
	}
`;
export const ResourceFragmentDoc = gql`
	fragment resource on Resource {
		id
		title
		resourceType
		image {
			rendition(fill: "320x360") {
				...imageRenditionFields
			}
		}
		url
	}
	${ImageRenditionFieldsFragmentDoc}
`;
export const ResourcesBlockFragmentDoc = gql`
	fragment resourcesBlock on ResourcesBlock {
		resourcesTitle: title
		featured
		resources {
			...resource
		}
	}
	${ResourceFragmentDoc}
`;
export const ImageContentFragmentDoc = gql`
	fragment imageContent on ImageContentBlock {
		imageTitle: title
		direction
		superTitle
		content
		contentImage: image {
			rendition(fill: "740x800") {
				...imageRenditionFields
			}
		}
		link
		linkText
	}
	${ImageRenditionFieldsFragmentDoc}
`;
export const StatBlockFragmentDoc = gql`
	fragment statBlock on StatBlock {
		stat
		statDescription
	}
`;
export const StatsBlockFragmentDoc = gql`
	fragment statsBlock on StatsBlock {
		statsTitle: title
		statsImage: image {
			rendition(fill: "640x640") {
				...imageRenditionFields
			}
		}
		stats {
			... on StatBlock {
				...statBlock
			}
		}
	}
	${ImageRenditionFieldsFragmentDoc}
	${StatBlockFragmentDoc}
`;
export const QuickLinksFragmentDoc = gql`
	fragment quickLinks on QuickLinksBlock {
		id
		title
		links {
			...External
			...Internal
		}
	}
	${ExternalFragmentDoc}
	${InternalFragmentDoc}
`;
export const HomePageFragmentDoc = gql`
	fragment homePage on HomePage {
		path
		title
		slug
		seoTitle
		searchDescription
		pageType
		searchImage {
			rendition(fill: "1200x627") {
				...imageRenditionFields
			}
		}
		heroTagline
		heroImage {
			rendition(fill: "1920x1080") {
				...imageRenditionFields
			}
		}
		heroLinks {
			...External
			...Internal
		}
		introLinks {
			...External
			...Internal
		}
		introText
		learnMoreLink
		learnMoreLabel
		body {
			id
			blockType
			...resourcesBlock
			...imageContent
			...statsBlock
			...quickLinks
		}
	}
	${ImageRenditionFieldsFragmentDoc}
	${ExternalFragmentDoc}
	${InternalFragmentDoc}
	${ResourcesBlockFragmentDoc}
	${ImageContentFragmentDoc}
	${StatsBlockFragmentDoc}
	${QuickLinksFragmentDoc}
`;
export const LandingPageFragmentDoc = gql`
	fragment landingPage on LandingPage {
		path
		title
		slug
		seoTitle
		searchDescription
		pageType
		searchImage {
			rendition(fill: "1200x627") {
				...imageRenditionFields
			}
		}
		heroTagline
		heroImage {
			rendition(fill: "1920x1080") {
				...imageRenditionFields
			}
		}
		heroLinks {
			...External
			...Internal
		}
		introLinks {
			...External
			...Internal
		}
		introText
		learnMoreLink
		learnMoreLabel
		body {
			id
			blockType
			...resourcesBlock
			...imageContent
			...statsBlock
			...quickLinks
		}
	}
	${ImageRenditionFieldsFragmentDoc}
	${ExternalFragmentDoc}
	${InternalFragmentDoc}
	${ResourcesBlockFragmentDoc}
	${ImageContentFragmentDoc}
	${StatsBlockFragmentDoc}
	${QuickLinksFragmentDoc}
`;
export const RichtextWithHeadingFragmentDoc = gql`
	fragment richtextWithHeading on RichtextWithHeadingBlock {
		heading
		richtext
	}
`;
export const CaptionedImageFragmentDoc = gql`
	fragment captionedImage on CaptionedImageBlock {
		caption
		image {
			rendition(width: 1200) {
				...imageRenditionFields
			}
		}
	}
	${ImageRenditionFieldsFragmentDoc}
`;
export const RichtextWithImageFragmentDoc = gql`
	fragment richtextWithImage on RichtextWithImageBlock {
		captionedImage: image {
			...captionedImage
		}
		imageRichtext: richtext
	}
	${CaptionedImageFragmentDoc}
`;
export const FullWidthImageFragmentDoc = gql`
	fragment fullWidthImage on FullWidthImageBlock {
		captionedImage: image {
			...captionedImage
		}
	}
	${CaptionedImageFragmentDoc}
`;
export const ProfileFragmentDoc = gql`
	fragment profile on ProfileBlock {
		title
		content
		image {
			rendition(width: 450) {
				...imageRenditionFields
			}
		}
	}
	${ImageRenditionFieldsFragmentDoc}
`;
export const ProfileListFragmentDoc = gql`
	fragment profileList on ProfileListBlock {
		heading: title
		intro
		profiles {
			... on ProfileBlock {
				...profile
			}
		}
	}
	${ProfileFragmentDoc}
`;
export const LogoListFragmentDoc = gql`
	fragment logoList on LogoListBlock {
		title
		logos {
			id
			... on ImageObjectType {
				rendition(width: 220) {
					...imageRenditionFields
				}
			}
		}
	}
	${ImageRenditionFieldsFragmentDoc}
`;
export const VideoEmbedBlockFragmentDoc = gql`
	fragment videoEmbedBlock on VideoEmbedBlock {
		title
		url
	}
`;
export const ContentPageFragmentDoc = gql`
	fragment contentPage on ContentPage {
		searchImage {
			rendition(fill: "1200x627") {
				...imageRenditionFields
			}
		}
		heroImage {
			rendition(fill: "1400x800") {
				...imageRenditionFields
			}
		}
		body {
			id
			blockType
			...richtextWithHeading
			...richtextWithImage
			...fullWidthImage
			...profileList
			...logoList
			...videoEmbedBlock
			... on FormBlock {
				formTitle
				emailTo
				thankYouMessage
				formFields {
					... on FieldBlock {
						fieldLabel
						fieldName
						fieldType
						isRequired
						placeholder
						defaultValue
						helpText
					}
					... on ChoiceFieldBlock {
						fieldLabel
						fieldName
						fieldType
						isRequired
						choices
						helpText
					}
					... on FileFieldBlock {
						fieldLabel
						fieldName
						helpText
						isRequired
					}
					... on CheckboxFieldBlock {
						fieldLabel
						fieldName
						isRequired
						helpText
					}
				}
			}
		}
	}
	${ImageRenditionFieldsFragmentDoc}
	${RichtextWithHeadingFragmentDoc}
	${RichtextWithImageFragmentDoc}
	${FullWidthImageFragmentDoc}
	${ProfileListFragmentDoc}
	${LogoListFragmentDoc}
	${VideoEmbedBlockFragmentDoc}
`;
export const ResourceNodeFragmentDoc = gql`
	fragment resourceNode on ResourceNode {
		id
		title
		resourceType
		image {
			rendition(fill: "320x360") {
				...imageRenditionFields
			}
		}
		url
	}
	${ImageRenditionFieldsFragmentDoc}
`;
export const GetHeaderMenuDocument = gql`
	query getHeaderMenu {
		menuSettings {
			menu {
				id
				blockType
				...Internal
				...External
			}
		}
	}
	${InternalFragmentDoc}
	${ExternalFragmentDoc}
`;

/**
 * __useGetHeaderMenuQuery__
 *
 * To run a query within a React component, call `useGetHeaderMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderMenuQuery(
	baseOptions?: Apollo.QueryHookOptions<GetHeaderMenuQuery, GetHeaderMenuQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetHeaderMenuQuery, GetHeaderMenuQueryVariables>(GetHeaderMenuDocument, options);
}
export function useGetHeaderMenuLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderMenuQuery, GetHeaderMenuQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetHeaderMenuQuery, GetHeaderMenuQueryVariables>(GetHeaderMenuDocument, options);
}
export type GetHeaderMenuQueryHookResult = ReturnType<typeof useGetHeaderMenuQuery>;
export type GetHeaderMenuLazyQueryHookResult = ReturnType<typeof useGetHeaderMenuLazyQuery>;
export type GetHeaderMenuQueryResult = Apollo.QueryResult<GetHeaderMenuQuery, GetHeaderMenuQueryVariables>;
export const GetFooterSettingsDocument = gql`
	query getFooterSettings {
		footerSettings {
			acknowledgementOfCountry
			address
			contactPhone
			socialMediaLinks {
				...External
			}
			legalLinks {
				...Internal
				...External
			}
		}
	}
	${ExternalFragmentDoc}
	${InternalFragmentDoc}
`;

/**
 * __useGetFooterSettingsQuery__
 *
 * To run a query within a React component, call `useGetFooterSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFooterSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFooterSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFooterSettingsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetFooterSettingsQuery, GetFooterSettingsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetFooterSettingsQuery, GetFooterSettingsQueryVariables>(GetFooterSettingsDocument, options);
}
export function useGetFooterSettingsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetFooterSettingsQuery, GetFooterSettingsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetFooterSettingsQuery, GetFooterSettingsQueryVariables>(
		GetFooterSettingsDocument,
		options,
	);
}
export type GetFooterSettingsQueryHookResult = ReturnType<typeof useGetFooterSettingsQuery>;
export type GetFooterSettingsLazyQueryHookResult = ReturnType<typeof useGetFooterSettingsLazyQuery>;
export type GetFooterSettingsQueryResult = Apollo.QueryResult<GetFooterSettingsQuery, GetFooterSettingsQueryVariables>;
export const ContactDocument = gql`
	mutation contact($input: ContactMutationInput!) {
		contact(input: $input) {
			errors {
				field
				messages
			}
		}
	}
`;
export type ContactMutationFn = Apollo.MutationFunction<ContactMutation, ContactMutationVariables>;

/**
 * __useContactMutation__
 *
 * To run a mutation, you first call `useContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactMutation, { data, loading, error }] = useContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactMutation(
	baseOptions?: Apollo.MutationHookOptions<ContactMutation, ContactMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContactMutation, ContactMutationVariables>(ContactDocument, options);
}
export type ContactMutationHookResult = ReturnType<typeof useContactMutation>;
export type ContactMutationResult = Apollo.MutationResult<ContactMutation>;
export type ContactMutationOptions = Apollo.BaseMutationOptions<ContactMutation, ContactMutationVariables>;
export const AllPagesDocument = gql`
	query allPages($hostname: String!) {
		site(hostname: $hostname) {
			pages {
				id
				live
				urlPath
			}
		}
	}
`;

/**
 * __useAllPagesQuery__
 *
 * To run a query within a React component, call `useAllPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPagesQuery({
 *   variables: {
 *      hostname: // value for 'hostname'
 *   },
 * });
 */
export function useAllPagesQuery(baseOptions: Apollo.QueryHookOptions<AllPagesQuery, AllPagesQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AllPagesQuery, AllPagesQueryVariables>(AllPagesDocument, options);
}
export function useAllPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPagesQuery, AllPagesQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AllPagesQuery, AllPagesQueryVariables>(AllPagesDocument, options);
}
export type AllPagesQueryHookResult = ReturnType<typeof useAllPagesQuery>;
export type AllPagesLazyQueryHookResult = ReturnType<typeof useAllPagesLazyQuery>;
export type AllPagesQueryResult = Apollo.QueryResult<AllPagesQuery, AllPagesQueryVariables>;
export const PageDocument = gql`
	query page($hostname: String!, $urlPath: String!, $token: String, $contentType: String) {
		site(hostname: $hostname) {
			siteName
			hostname
			page(urlPath: $urlPath, token: $token, contentType: $contentType) {
				id
				title
				slug
				url
				urlPath
				pageType
				seoTitle
				searchDescription
				... on ContentPage {
					...contentPage
				}
				... on HomePage {
					...homePage
				}
				... on LandingPage {
					...landingPage
				}
				... on ContactPage {
					id
					thankYouText
					subjects
					roles
				}
			}
		}
	}
	${ContentPageFragmentDoc}
	${HomePageFragmentDoc}
	${LandingPageFragmentDoc}
`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      hostname: // value for 'hostname'
 *      urlPath: // value for 'urlPath'
 *      token: // value for 'token'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
}
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
}
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const GetPreviewPathDocument = gql`
	query getPreviewPath($token: String, $contentType: String) {
		page(token: $token, contentType: $contentType) {
			urlPath
		}
	}
`;

/**
 * __useGetPreviewPathQuery__
 *
 * To run a query within a React component, call `useGetPreviewPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewPathQuery({
 *   variables: {
 *      token: // value for 'token'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useGetPreviewPathQuery(
	baseOptions?: Apollo.QueryHookOptions<GetPreviewPathQuery, GetPreviewPathQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetPreviewPathQuery, GetPreviewPathQueryVariables>(GetPreviewPathDocument, options);
}
export function useGetPreviewPathLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewPathQuery, GetPreviewPathQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetPreviewPathQuery, GetPreviewPathQueryVariables>(GetPreviewPathDocument, options);
}
export type GetPreviewPathQueryHookResult = ReturnType<typeof useGetPreviewPathQuery>;
export type GetPreviewPathLazyQueryHookResult = ReturnType<typeof useGetPreviewPathLazyQuery>;
export type GetPreviewPathQueryResult = Apollo.QueryResult<GetPreviewPathQuery, GetPreviewPathQueryVariables>;
export const SearchResourcesDocument = gql`
	query searchResources($query: String!) {
		resources(search: $query) {
			...resourceNode
		}
	}
	${ResourceNodeFragmentDoc}
`;

/**
 * __useSearchResourcesQuery__
 *
 * To run a query within a React component, call `useSearchResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchResourcesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchResourcesQuery(
	baseOptions: Apollo.QueryHookOptions<SearchResourcesQuery, SearchResourcesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SearchResourcesQuery, SearchResourcesQueryVariables>(SearchResourcesDocument, options);
}
export function useSearchResourcesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SearchResourcesQuery, SearchResourcesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SearchResourcesQuery, SearchResourcesQueryVariables>(SearchResourcesDocument, options);
}
export type SearchResourcesQueryHookResult = ReturnType<typeof useSearchResourcesQuery>;
export type SearchResourcesLazyQueryHookResult = ReturnType<typeof useSearchResourcesLazyQuery>;
export type SearchResourcesQueryResult = Apollo.QueryResult<SearchResourcesQuery, SearchResourcesQueryVariables>;
